
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("73TCo", function(module, exports) {

var $42omo = parcelRequire("42omo");





var $9s8in = parcelRequire("9s8in");


var $aDFyc = parcelRequire("aDFyc");


var $jmjWc = parcelRequire("jmjWc");


var $7aRa9 = parcelRequire("7aRa9");


const $3dcdb07ca5337b62$var$FloatingAudioContentLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DuuaU",
    name: "FloatingAudioContentLoadable",
    loader: async ()=>(await (parcelRequire("jObSn"))).FloatingAudioContent
});
const $3dcdb07ca5337b62$export$d559f44428716fef = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const { isOpen: isOpen } = (0, $9s8in.useAudioPlayerStore)();
    (0, $aDFyc.useAudioPlayerIframeListener)();
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3dcdb07ca5337b62$var$FloatingAudioContentLoadable, {
        flags: flags
    }) : null;
});



var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");








var $bAyaS = parcelRequire("bAyaS");


const $60b070effa9833b5$var$CreateSpaceDrawerLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8t-EL",
    name: "CreateSpaceDrawerLoader",
    loader: async ()=>(await (parcelRequire("2iVyz"))).CreateSpaceDrawer
});
const $60b070effa9833b5$export$8b3b261467ad7423 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const [shouldRenderDrawer] = (0, $bAyaS.useShouldRenderDrawer)();
    let t0;
    if ($[0] !== shouldRenderDrawer) {
        t0 = shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($60b070effa9833b5$var$CreateSpaceDrawerLoader, null) : null;
        $[0] = shouldRenderDrawer;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const [shouldRenderDrawer] = (0, $bAyaS.useShouldRenderDrawer)();
    return shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($60b070effa9833b5$var$CreateSpaceDrawerLoader, null) : null;
};



var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");











var $dPJCf = parcelRequire("dPJCf");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1NBp8 = parcelRequire("1NBp8");


var $7Ndnw = parcelRequire("7Ndnw");


var $dizL5 = parcelRequire("dizL5");


var $8a9Dm = parcelRequire("8a9Dm");


var $4vC63 = parcelRequire("4vC63");

const $053fc94f5ddb8d12$export$d15e21537dfa6cb0 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t0;
    if ($[0] !== push) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
            moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
            render: (forgeModules, loading, error)=>{
                if (loading) return null;
                if (error) {
                    if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                        error: error
                    });
                    return null;
                }
                return forgeModules.map((module)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
                        key: module.id,
                        module: module,
                        action: ()=>push((0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
                                appId: (0, $8a9Dm.getAppId)(module),
                                envId: module.environmentId,
                                forgeManifestRoute: module.properties.route
                            }))
                    }));
            }
        });
        $[0] = push;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
        render: (forgeModules, loading, error)=>{
            if (loading) return null;
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
                return null;
            }
            return forgeModules.map((module)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
                    key: module.id,
                    module: module,
                    action: ()=>push((0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
                            appId: (0, $8a9Dm.getAppId)(module),
                            envId: module.environmentId,
                            forgeManifestRoute: module.properties.route
                        }))
                }));
        }
    });
});


parcelRequire("h3wYQ");
var $cQbTj = parcelRequire("cQbTj");
var $f8AFM = parcelRequire("f8AFM");

parcelRequire("lfopc");
var $l1elF = parcelRequire("l1elF");





var $6mKj3 = parcelRequire("6mKj3");





const $ceaefb39b3ad51ae$var$FloatingEnterpriseHerContentLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5oeLQ",
    name: "FloatingEnterpriseHerContentLoadable",
    loader: async ()=>(await (parcelRequire("gCDQT"))).FloatingEnterpriseHerContent
});
const $ceaefb39b3ad51ae$export$2ae52161c1f11a14 = ()=>{
    if (!(0, $6mKj3.expVal)('enterprise_her', 'isEnabled', false)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ceaefb39b3ad51ae$var$FloatingEnterpriseHerContentLoadable, null);
};



var $hAnPj = parcelRequire("hAnPj");











var $alLTz = parcelRequire("alLTz");


const $3729a951937314e9$var$StorageEnforcementFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_U9ss",
    name: "StorageEnforcementFlagsLoadable",
    loader: async ()=>(await (parcelRequire("b6DNq"))).StorageEnforcementFlags
});
const $3729a951937314e9$export$8df08a490eb32a33 = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3729a951937314e9$var$StorageEnforcementFlagsLoadable, null) : null;
};












const $372cb008daefafdd$var$GracePeriodModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "6zo21",
    name: "GracePeriodModalLoadable",
    loader: async ()=>(await (parcelRequire("aOp12"))).GracePeriodModalErrorBoundary
});
const $372cb008daefafdd$export$38134b9c38b2723c = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($372cb008daefafdd$var$GracePeriodModalLoadable, null) : null;
};












const $2c6a471f2dd5d9be$var$BlockCreateModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Mxabm",
    name: "BlockCreateModalLoadable",
    loader: async ()=>(await (parcelRequire("5BRIl"))).BlockCreateModal
});
const $2c6a471f2dd5d9be$export$4bd1fbb328f3ee8b = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c6a471f2dd5d9be$var$BlockCreateModalLoadable, null) : null;
};


const $7ac3d7089b8f08ca$export$5bf713f6291006b2 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3729a951937314e9$export$8df08a490eb32a33), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $372cb008daefafdd$export$38134b9c38b2723c), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c6a471f2dd5d9be$export$4bd1fbb328f3ee8b), null));
};












var $i3jcY = parcelRequire("i3jcY");





const $115e4f8cc2211b97$export$1b00dbfc05a9ac4b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KjI9E",
    name: "EndOfTrialModalContainerWithErrorBoundaryLoadable",
    loader: async ()=>(await (parcelRequire("awHil"))).EndOfTrialModalContainerWithErrorBoundary
});



var $9wGTI = parcelRequire("9wGTI");



// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $8AKrx = parcelRequire("8AKrx");


var $4S8ti = parcelRequire("4S8ti");



const $fcf149ef3fc7ff73$export$99c76ad477e76512 = ()=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_PUMA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthPuma'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S8ti.CrossJoinNudgesWithFlags), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthArtemis'
        }
    }, (0, $9wGTI.fg)('twcg-530_confluence_ai_in_editor_eot_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $115e4f8cc2211b97$export$1b00dbfc05a9ac4b), null)));
};




















// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 






const $63d46b1fc54f0401$var$NthUserOrientationLoadable = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pjDSS",
    name: "NthUserOrientationLoadable",
    loader: async ()=>(await (parcelRequire("2qwfL"))).NthUserOrientation
});
const $63d46b1fc54f0401$export$11a38f66cbb85629 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($63d46b1fc54f0401$var$NthUserOrientationLoadable, null);
};



const $a62f4f3e55485b0c$var$RovoAnnouncementSplashModalLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Gg8Jr",
    name: "RovoAnnouncementSplashModalLoadable",
    loader: async ()=>(await (parcelRequire("HH4KZ"))).RovoAnnouncementSplashModal
});
const $a62f4f3e55485b0c$export$d440a40388af1c12 = ()=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CE_MAU
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63d46b1fc54f0401$export$11a38f66cbb85629), null)), (0, $9wGTI.fg)('aifc_onboarding_ga_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_FEATURE_DISCOVERY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a62f4f3e55485b0c$var$RovoAnnouncementSplashModalLoadable, null)));
};


















const $363c2f84aa85fa56$var$SmartCreationModalLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Sb6aM",
    name: "SmartCreationModalLoadable",
    loader: async ()=>(await (parcelRequire("5GsAe"))).ConfluenceSmartCreationModalLoader
});
const $363c2f84aa85fa56$export$fa257c3858869fed = ()=>{
    if (!(0, $9wGTI.fg)('aifc_create_enabled')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Smarts'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($363c2f84aa85fa56$var$SmartCreationModalLoadable, null));
};















var $c5zvz = parcelRequire("c5zvz");














var $euL71 = parcelRequire("euL71");


var $fcF01 = parcelRequire("fcF01");


const $8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "z7feK",
    name: "LazyExperimentPlanSelectionModal",
    loader: async ()=>(await (parcelRequire("fQudG"))).ExperimentPlanSelectionModal
});
const $8e4a487f1ccf39b0$export$7699251dbf86d265 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    const { currentEdition: currentEdition } = (0, $42omo.useContext)((0, $fcF01.UpFlowContext));
    let t0;
    if ($[0] !== currentEdition) {
        t0 = currentEdition === (0, $euL71.ConfluenceEdition).FREE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal, null);
        $[0] = currentEdition;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { currentEdition: currentEdition } = (0, $42omo.useContext)((0, $fcF01.UpFlowContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, currentEdition === (0, $euL71.ConfluenceEdition).FREE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e4a487f1ccf39b0$var$LazyExperimentPlanSelectionModal, null));
};






var $aJv6Q = parcelRequire("aJv6Q");








const $f7a2cd2323bccfe9$var$TrialFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uEpNB",
    name: "TrialFlagsLoadable",
    loader: async ()=>(await (parcelRequire("iqdmV"))).TrialFlags
});
const $f7a2cd2323bccfe9$export$c108f21945b8b79 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).GROWTH_LUNA
})(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f7a2cd2323bccfe9$var$TrialFlagsLoadable, null));


const $869a3ecc023117fa$export$7e65e5c9acad9939 = ()=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
        attributes: {
            errorBoundaryId: 'GlobalComponents-GrowthLuna'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8e4a487f1ccf39b0$export$7699251dbf86d265), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5zvz.StandardToPremiumModalMountComponent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7a2cd2323bccfe9$export$c108f21945b8b79), null));
};


const $21316eb17a577fc6$export$461c2ed3163c74ff = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Disco'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $60b070effa9833b5$export$8b3b261467ad7423), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $363c2f84aa85fa56$export$fa257c3858869fed), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CC_IMPORTER,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Importer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8AFM.ConditionalImportContentModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cQbTj.ConditionalImportContentDrawer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l1elF.ConditionalSingleImportModal), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Ecosystem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $053fc94f5ddb8d12$export$d15e21537dfa6cb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE,
        attributes: {
            errorBoundaryId: 'GlobalComponents-AdminExperience'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ac3d7089b8f08ca$export$5bf713f6291006b2), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $869a3ecc023117fa$export$7e65e5c9acad9939), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hAnPj.LazyRestrictionsDialogMountPoint), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a62f4f3e55485b0c$export$d440a40388af1c12), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fcf149ef3fc7ff73$export$99c76ad477e76512), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS,
        attributes: {
            errorBoundaryId: 'GlobalComponents-Audio'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dcdb07ca5337b62$export$d559f44428716fef), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS,
        attributes: {
            errorBoundaryId: 'GlobalComponents-HER'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ceaefb39b3ad51ae$export$2ae52161c1f11a14), null)));
};
module.exports["GlobalComponents"] = $21316eb17a577fc6$export$461c2ed3163c74ff;

});

parcelRegister("aDFyc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9s8in = parcelRequire("9s8in");

const $2d668387d97f8250$export$c4a6bbd66a3ec4f3 = 'AUDIO_PLAYER_OPEN_REQUEST';
const $2d668387d97f8250$var$isAudioPlayerIframeMessage = (data)=>{
    if (!data || typeof data !== 'object') return false;
    const message = data;
    return message.type === $2d668387d97f8250$export$c4a6bbd66a3ec4f3 && message.activeContent != null;
};
const $2d668387d97f8250$export$ce895abfddbf56a4 = ()=>{
    const { openAudioPlayer: openAudioPlayer } = (0, $9s8in.useAudioPlayerStore)();
    (0, $42omo.useEffect)(()=>{
        const handleMessage = (event)=>{
            if (!$2d668387d97f8250$var$isAudioPlayerIframeMessage(event.data)) return;
            openAudioPlayer(event.data.activeContent, event.data.options);
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        openAudioPlayer
    ]);
};
module.exports["AUDIO_PLAYER_OPEN_REQUEST"] = $2d668387d97f8250$export$c4a6bbd66a3ec4f3;
module.exports["useAudioPlayerIframeListener"] = $2d668387d97f8250$export$ce895abfddbf56a4;

});

parcelRegister("jObSn", function(module, exports) {

let $e6bbe62dfa7f0a45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e6bbe62dfa7f0a45$var$load("5aEHs"),
    $e6bbe62dfa7f0a45$var$load("9HZKr"),
    $e6bbe62dfa7f0a45$var$load("kbwlB"),
    $e6bbe62dfa7f0a45$var$load("3Zwna"),
    $e6bbe62dfa7f0a45$var$load("jDjSj"),
    $e6bbe62dfa7f0a45$var$load("3R2Cd"),
    $e6bbe62dfa7f0a45$var$load("7t5Ax"),
    $e6bbe62dfa7f0a45$var$load("lVBal"),
    $e6bbe62dfa7f0a45$var$load("8gJl0"),
    $e6bbe62dfa7f0a45$var$load("2Gceu"),
    $e6bbe62dfa7f0a45$var$load("lLK0D"),
    $e6bbe62dfa7f0a45$var$load("fisfU"),
    $e6bbe62dfa7f0a45$var$load("gfGrm"),
    $e6bbe62dfa7f0a45$var$load("24u6w"),
    $e6bbe62dfa7f0a45$var$load("27glK"),
    $e6bbe62dfa7f0a45$var$load("bvY53"),
    $e6bbe62dfa7f0a45$var$load("gFEtJ"),
    $e6bbe62dfa7f0a45$var$load("gT8XU"),
    $e6bbe62dfa7f0a45$var$load("3Mspc"),
    $e6bbe62dfa7f0a45$var$load("8Fbef"),
    $e6bbe62dfa7f0a45$var$load("iivLa"),
    $e6bbe62dfa7f0a45$var$load("6wr18"),
    $e6bbe62dfa7f0a45$var$load("dek7I"),
    $e6bbe62dfa7f0a45$var$load("cyGuT"),
    $e6bbe62dfa7f0a45$var$load("hhss7"),
    $e6bbe62dfa7f0a45$var$load("fdKpi"),
    $e6bbe62dfa7f0a45$var$load("k2R9e"),
    $e6bbe62dfa7f0a45$var$load("7kkP6"),
    $e6bbe62dfa7f0a45$var$load("ffEVr"),
    $e6bbe62dfa7f0a45$var$load("l22f4"),
    $e6bbe62dfa7f0a45$var$load("6VoH9"),
    $e6bbe62dfa7f0a45$var$load("fNa2t"),
    $e6bbe62dfa7f0a45$var$load("eTYdV"),
    $e6bbe62dfa7f0a45$var$load("7tgvK"),
    $e6bbe62dfa7f0a45$var$load("6Ji1C"),
    $e6bbe62dfa7f0a45$var$load("Wowvf"),
    $e6bbe62dfa7f0a45$var$load("cRtGo"),
    $e6bbe62dfa7f0a45$var$load("7EorR"),
    $e6bbe62dfa7f0a45$var$load("3WaAl")
]).then(()=>parcelRequire('iLFiU'));

});

parcelRegister("bAyaS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $9zUhf.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
module.exports["useCreateSpaceStore"] = $8eabddf4fe78ba91$export$5642c413017336a4;
module.exports["useShouldRenderDrawer"] = $8eabddf4fe78ba91$export$34596812152477bc;
module.exports["useCreateSpaceStoreActions"] = $8eabddf4fe78ba91$export$ad3d638eaaafd693;

});

parcelRegister("2iVyz", function(module, exports) {

let $1ad9e8bc0ac5178d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ad9e8bc0ac5178d$var$load("8j9XC"),
    $1ad9e8bc0ac5178d$var$load("f35QR"),
    $1ad9e8bc0ac5178d$var$load("eVYW1"),
    $1ad9e8bc0ac5178d$var$load("ls0Um"),
    $1ad9e8bc0ac5178d$var$load("020xd"),
    $1ad9e8bc0ac5178d$var$load("eTBsW"),
    $1ad9e8bc0ac5178d$var$load("bYxCZ"),
    $1ad9e8bc0ac5178d$var$load("6HBYC"),
    $1ad9e8bc0ac5178d$var$load("eDqo1"),
    $1ad9e8bc0ac5178d$var$load("lxiFd"),
    $1ad9e8bc0ac5178d$var$load("1oiJ6"),
    $1ad9e8bc0ac5178d$var$load("huUvS"),
    $1ad9e8bc0ac5178d$var$load("6wr18"),
    $1ad9e8bc0ac5178d$var$load("ehQBw"),
    $1ad9e8bc0ac5178d$var$load("amPsT"),
    $1ad9e8bc0ac5178d$var$load("19uFC"),
    $1ad9e8bc0ac5178d$var$load("a3Uq6"),
    $1ad9e8bc0ac5178d$var$load("hOaAV"),
    $1ad9e8bc0ac5178d$var$load("1qlDN"),
    $1ad9e8bc0ac5178d$var$load("1yVM6"),
    $1ad9e8bc0ac5178d$var$load("6XCf4"),
    $1ad9e8bc0ac5178d$var$load("cEqm7"),
    $1ad9e8bc0ac5178d$var$load("fsikk"),
    $1ad9e8bc0ac5178d$var$load("5pvpJ"),
    $1ad9e8bc0ac5178d$var$load("6vhrJ"),
    $1ad9e8bc0ac5178d$var$load("fxC6e"),
    $1ad9e8bc0ac5178d$var$load("hhss7"),
    $1ad9e8bc0ac5178d$var$load("kHOMt"),
    $1ad9e8bc0ac5178d$var$load("ffEVr"),
    $1ad9e8bc0ac5178d$var$load("7EorR"),
    $1ad9e8bc0ac5178d$var$load("Wowvf"),
    $1ad9e8bc0ac5178d$var$load("cRtGo"),
    $1ad9e8bc0ac5178d$var$load("atyNV")
]).then(()=>parcelRequire('1tDKi'));

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kvnZB"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kvnZB", function(module, exports) {

let $eed95052bea62898$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eed95052bea62898$var$load("iEUHW"),
    $eed95052bea62898$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("4vC63", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { module: module, tooltip: t1, children: children } = t0;
    const tooltip = t1 === undefined ? "" : t1;
    let accelerator;
    let t2;
    if ($[0] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t2 = accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = module;
        $[1] = accelerator;
        $[2] = t2;
    } else {
        accelerator = $[1];
        t2 = $[2];
    }
    if (t2) {
        const t3 = `forge-keyboard-shortcut-visualizer-${accelerator}`;
        let t4;
        if ($[3] !== accelerator || $[4] !== tooltip) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: accelerator,
                contentBefore: tooltip,
                isTooltip: true
            });
            $[3] = accelerator;
            $[4] = tooltip;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== children || $[7] !== t3 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                tag: "span",
                testId: t3,
                content: t4
            }, children);
            $[6] = children;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t3;
    if ($[10] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[10] = children;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { module: module, action: action } = t0;
    let accelerator;
    let t1;
    if ($[0] !== action || $[1] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t1 = accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = action;
        $[1] = module;
        $[2] = accelerator;
        $[3] = t1;
    } else {
        accelerator = $[2];
        t1 = $[3];
    }
    if (t1) {
        const t2 = `forge-keyboard-shortcut-${accelerator}`;
        let t3;
        if ($[4] !== accelerator || $[5] !== action) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
                accelerator: accelerator,
                listener: action,
                shortcutType: (0, $bflGB.ShortcutType).Forge
            });
            $[4] = accelerator;
            $[5] = action;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": t2
            }, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    return null;
} : ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("h3wYQ", function(module, exports) {
$parcel$export(module.exports, "ConditionalImportContentDrawer", () => (parcelRequire("cQbTj")).ConditionalImportContentDrawer);
$parcel$export(module.exports, "ConditionalImportContentModal", () => (parcelRequire("f8AFM")).ConditionalImportContentModal);
$parcel$export(module.exports, "ImportContentButton", () => (parcelRequire("gKGjM")).ImportContentButton);
$parcel$export(module.exports, "useImportContentStoreActions", () => (parcelRequire("5IN3L")).useImportContentStoreActions);

var $cQbTj = parcelRequire("cQbTj");


var $f8AFM = parcelRequire("f8AFM");


var $gKGjM = parcelRequire("gKGjM");


var $5IN3L = parcelRequire("5IN3L");


});

parcelRegister("cQbTj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $5IN3L = parcelRequire("5IN3L");


const $8584efcc44eb8061$var$ImportContentDrawerLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "R258E",
    name: "ImportContentDrawerLoader",
    loader: async ()=>(await (parcelRequire("6L3SK"))).ImportContentDrawer
});
const $8584efcc44eb8061$export$5aeeed7cf265bb36 = ()=>{
    const [importContentState, importContentActions] = (0, $5IN3L.useImportContentStore)();
    return importContentState.shouldRenderDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8584efcc44eb8061$var$ImportContentDrawerLoader, {
        isImportingContent: importContentState.showImportContentDrawer,
        setIsImportingContent: importContentActions.setShowImportContentDrawer,
        contentType: importContentState.contentType
    }) : null;
};
module.exports["ConditionalImportContentDrawer"] = $8584efcc44eb8061$export$5aeeed7cf265bb36;

});

parcelRegister("5IN3L", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $8uc8a = parcelRequire("8uc8a");


var $27ffu = parcelRequire("27ffu");


var $dzqet = parcelRequire("dzqet");

const $c73c161a517b87e3$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: {
        showImportContentDrawer: false,
        shouldRenderDrawer: false,
        showImportContentModal: false,
        shouldRenderModal: false,
        shouldRenderMiroTokenModal: false,
        contentType: (0, $dzqet.ContentType).NOTION
    },
    actions: {
        setShowImportContentDrawer: (value)=>({ setState: setState })=>{
                setState({
                    showImportContentDrawer: value
                });
            },
        setShouldRenderDrawer: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderDrawer: value
                });
            },
        setShowImportContentModal: (value)=>({ setState: setState })=>{
                setState({
                    showImportContentModal: value
                });
            },
        setShouldRenderModal: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderModal: value
                });
            },
        setShouldRenderMiroTokenModal: (value)=>({ setState: setState })=>{
                setState({
                    shouldRenderMiroTokenModal: value
                });
            },
        setContentType: (value)=>({ setState: setState })=>{
                setState({
                    contentType: value
                });
            }
    },
    name: 'importContentStore'
});
const $c73c161a517b87e3$export$7805c3dc7bda328d = /*#__PURE__*/ (0, $42omo.createContext)({
    authProviderError: '',
    setAuthProviderError: ()=>{},
    hasSubpages: false,
    setHasSubpages: ()=>{},
    dropzoneCancelFnRef: {
        current: null
    },
    browserCancelFnRef: {
        current: null
    },
    isUploadingFile: false,
    setIsUploadingFile: ()=>{},
    isStartingImport: false,
    setIsStartingImport: ()=>{},
    fileNameDisplay: '',
    setFileNameDisplay: ()=>{},
    fileSizeBytes: 0,
    setFileSizeBytes: ()=>{},
    filestoreId: '',
    setFilestoreId: ()=>{},
    migrationScopeId: '',
    setMigrationScopeId: ()=>{},
    migrationId: '',
    setMigrationId: ()=>{},
    collectionId: '',
    setCollectionId: ()=>{},
    shouldMapNotionMembers: true,
    setShouldMapNotionMembers: ()=>{},
    shouldRenderCloseDrawerModal: false,
    setShouldRenderCloseDrawerModal: ()=>{},
    shouldRenderIntegrationTokenModal: false,
    setShouldRenderIntegrationTokenModal: ()=>{},
    integrationToken: '',
    setIntegrationToken: ()=>{},
    shouldAddRemainingMembers: false,
    setShouldAddRemainingMembers: ()=>{},
    shouldCopyPagePermissions: false,
    setShouldCopyPagePermissions: ()=>{},
    shouldRenderAccessTokenModal: false,
    setShouldRenderAccessTokenModal: ()=>{},
    shouldExportEntities: true,
    setShouldExportEntities: ()=>{},
    accessToken: '',
    setAccessToken: ()=>{},
    refreshToken: '',
    setRefreshToken: ()=>{},
    tokenExpireAt: '',
    setTokenExpireAt: ()=>{},
    newSpaceName: '',
    setNewSpaceName: ()=>{},
    setExistingSpace: ()=>{},
    setParentPageId: ()=>{},
    selectedPermissions: (0, $8uc8a.PermissionOptions).DEFAULT,
    setSelectedPermissions: ()=>{},
    miroAuthToken: '',
    setMiroAuthToken: ()=>{},
    miroTeamId: '',
    setMiroTeamId: ()=>{},
    miroProjectId: null,
    setMiroProjectId: ()=>{},
    clearAllMiroBulkImportTokens: ()=>{},
    didReceiveMiroBulkApiTokens: false,
    setDidReceiveMiroBulkApiTokens: ()=>{},
    isNotionWorkspaceImportDisabled: false,
    setIsNotionWorkspaceImportDisabled: ()=>{},
    isValidatingZip: false,
    setIsValidatingZip: ()=>{}
});
const $c73c161a517b87e3$export$4261666d8e0efef2 = (props)=>{
    const [authProviderError, setAuthProviderError] = (0, $42omo.useState)('');
    const [hasSubpages, setHasSubpages] = (0, $42omo.useState)(false);
    const dropzoneCancelFnRef = (0, $42omo.useRef)(null);
    const browserCancelFnRef = (0, $42omo.useRef)(null);
    const [isUploadingFile, setIsUploadingFile] = (0, $42omo.useState)(false);
    const [isStartingImport, setIsStartingImport] = (0, $42omo.useState)(false);
    const [fileNameDisplay, setFileNameDisplay] = (0, $42omo.useState)('');
    const [fileSizeBytes, setFileSizeBytes] = (0, $42omo.useState)(0);
    const [filestoreId, setFilestoreId] = (0, $42omo.useState)('');
    const [migrationScopeId, setMigrationScopeId] = (0, $42omo.useState)('');
    const [migrationId, setMigrationId] = (0, $42omo.useState)('');
    const [collectionId, setCollectionId] = (0, $42omo.useState)('');
    const [shouldMapNotionMembers, setShouldMapNotionMembers] = (0, $42omo.useState)(true);
    const [shouldRenderIntegrationTokenModal, setShouldRenderIntegrationTokenModal] = (0, $42omo.useState)(false);
    const [shouldRenderCloseDrawerModal, setShouldRenderCloseDrawerModal] = (0, $42omo.useState)(false);
    const [integrationToken, setIntegrationToken] = (0, $42omo.useState)('');
    const [shouldAddRemainingMembers, setShouldAddRemainingMembers] = (0, $42omo.useState)(true);
    const [shouldCopyPagePermissions, setShouldCopyPagePermissions] = (0, $42omo.useState)(false);
    const [shouldRenderAccessTokenModal, setShouldRenderAccessTokenModal] = (0, $42omo.useState)(false);
    const [shouldExportEntities, setShouldExportEntities] = (0, $42omo.useState)(false);
    const [accessToken, setAccessToken] = (0, $42omo.useState)('');
    const [refreshToken, setRefreshToken] = (0, $42omo.useState)('');
    const [tokenExpireAt, setTokenExpireAt] = (0, $42omo.useState)('');
    const [newSpaceName, setNewSpaceName] = (0, $42omo.useState)('');
    const [existingSpace, setExistingSpace] = (0, $42omo.useState)();
    const [parentPageId, setParentPageId] = (0, $42omo.useState)();
    const [miroAuthToken, setMiroAuthToken] = (0, $42omo.useState)('');
    const [miroTeamId, setMiroTeamId] = (0, $42omo.useState)('');
    const [miroProjectId, setMiroProjectId] = (0, $42omo.useState)(null);
    const [didReceiveMiroBulkApiTokens, setDidReceiveMiroBulkApiTokens] = (0, $42omo.useState)(false);
    const [selectedPermissions, setSelectedPermissions] = (0, $42omo.useState)((0, $8uc8a.PermissionOptions).DEFAULT);
    const [isNotionWorkspaceImportDisabled, setIsNotionWorkspaceImportDisabled] = (0, $42omo.useState)(false);
    const [isValidatingZip, setIsValidatingZip] = (0, $42omo.useState)(false);
    const clearAllMiroBulkImportTokens = ()=>{
        setMiroAuthToken('');
        setMiroTeamId('');
        setMiroProjectId(null);
    };
    const setParentPageIdWithValidation = (rawParentPageId)=>{
        if (rawParentPageId === 'no-page-selection') setParentPageId(undefined);
        else setParentPageId(rawParentPageId);
    };
    const setMiroProjectIdWithValidation = (rawMiroProjectId)=>{
        if (rawMiroProjectId === '' || rawMiroProjectId === null) setMiroProjectId(null);
        else setMiroProjectId(rawMiroProjectId);
    };
    (0, $27ffu.useBeforeUnload)('Changes may not be saved', isUploadingFile || isStartingImport);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c73c161a517b87e3$export$7805c3dc7bda328d.Provider, {
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value: {
            authProviderError: authProviderError,
            setAuthProviderError: setAuthProviderError,
            hasSubpages: hasSubpages,
            setHasSubpages: setHasSubpages,
            dropzoneCancelFnRef: dropzoneCancelFnRef,
            browserCancelFnRef: browserCancelFnRef,
            isUploadingFile: isUploadingFile,
            setIsUploadingFile: setIsUploadingFile,
            isStartingImport: isStartingImport,
            setIsStartingImport: setIsStartingImport,
            fileNameDisplay: fileNameDisplay,
            setFileNameDisplay: setFileNameDisplay,
            fileSizeBytes: fileSizeBytes,
            setFileSizeBytes: setFileSizeBytes,
            filestoreId: filestoreId,
            setFilestoreId: setFilestoreId,
            migrationScopeId: migrationScopeId,
            setMigrationScopeId: setMigrationScopeId,
            migrationId: migrationId,
            setMigrationId: setMigrationId,
            collectionId: collectionId,
            setCollectionId: setCollectionId,
            shouldMapNotionMembers: shouldMapNotionMembers,
            setShouldMapNotionMembers: setShouldMapNotionMembers,
            shouldRenderCloseDrawerModal: shouldRenderCloseDrawerModal,
            setShouldRenderCloseDrawerModal: setShouldRenderCloseDrawerModal,
            shouldRenderIntegrationTokenModal: shouldRenderIntegrationTokenModal,
            setShouldRenderIntegrationTokenModal: setShouldRenderIntegrationTokenModal,
            shouldExportEntities: shouldExportEntities,
            setShouldExportEntities: setShouldExportEntities,
            integrationToken: integrationToken,
            setIntegrationToken: setIntegrationToken,
            shouldAddRemainingMembers: shouldAddRemainingMembers,
            setShouldAddRemainingMembers: setShouldAddRemainingMembers,
            shouldCopyPagePermissions: shouldCopyPagePermissions,
            setShouldCopyPagePermissions: setShouldCopyPagePermissions,
            shouldRenderAccessTokenModal: shouldRenderAccessTokenModal,
            setShouldRenderAccessTokenModal: setShouldRenderAccessTokenModal,
            accessToken: accessToken,
            setAccessToken: setAccessToken,
            refreshToken: refreshToken,
            setRefreshToken: setRefreshToken,
            tokenExpireAt: tokenExpireAt,
            setTokenExpireAt: setTokenExpireAt,
            newSpaceName: newSpaceName,
            setNewSpaceName: setNewSpaceName,
            existingSpace: existingSpace,
            parentPageId: parentPageId,
            setParentPageId: setParentPageIdWithValidation,
            setExistingSpace: setExistingSpace,
            selectedPermissions: selectedPermissions,
            setSelectedPermissions: setSelectedPermissions,
            miroAuthToken: miroAuthToken,
            setMiroAuthToken: setMiroAuthToken,
            miroTeamId: miroTeamId,
            setMiroTeamId: setMiroTeamId,
            miroProjectId: miroProjectId,
            setMiroProjectId: setMiroProjectIdWithValidation,
            clearAllMiroBulkImportTokens: clearAllMiroBulkImportTokens,
            didReceiveMiroBulkApiTokens: didReceiveMiroBulkApiTokens,
            setDidReceiveMiroBulkApiTokens: setDidReceiveMiroBulkApiTokens,
            isNotionWorkspaceImportDisabled: isNotionWorkspaceImportDisabled,
            setIsNotionWorkspaceImportDisabled: setIsNotionWorkspaceImportDisabled,
            isValidatingZip: isValidatingZip,
            setIsValidatingZip: setIsValidatingZip
        }
    }, props.children);
};
const $c73c161a517b87e3$export$316a7de2e8141cc8 = (0, $9zUhf.createHook)($c73c161a517b87e3$export$390f32400eaf98c9);
const $c73c161a517b87e3$export$21ba04a22063ba7c = (0, $9zUhf.createActionsHook)($c73c161a517b87e3$export$390f32400eaf98c9);
module.exports["ImportContentWorkflowContext"] = $c73c161a517b87e3$export$7805c3dc7bda328d;
module.exports["ImportContentWorkflowContextProvider"] = $c73c161a517b87e3$export$4261666d8e0efef2;
module.exports["useImportContentStore"] = $c73c161a517b87e3$export$316a7de2e8141cc8;
module.exports["useImportContentStoreActions"] = $c73c161a517b87e3$export$21ba04a22063ba7c;

});

parcelRegister("8uc8a", function(module, exports) {
var $9db47457289923c5$export$e64befb57ff51d2d = /*#__PURE__*/ function(PermissionOptions) {
    PermissionOptions["RESTRICTED"] = "RESTRICTED";
    PermissionOptions["NOTION"] = "NOTION";
    PermissionOptions["DEFAULT"] = "DEFAULT";
    return PermissionOptions;
}({});
module.exports["PermissionOptions"] = $9db47457289923c5$export$e64befb57ff51d2d;

});

parcelRegister("27ffu", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0a41942d2e8255bf$export$c0a586b329cae57d = (message, isUploadingFile)=>{
    (0, $42omo.useEffect)(()=>{
        if (isUploadingFile) {
            const handleBeforeUnload = (event)=>{
                event.preventDefault(); // Required to trigger the dialog in some browsers
                event.returnValue = message;
            };
            window.addEventListener('beforeunload', handleBeforeUnload);
            return ()=>{
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, [
        message,
        isUploadingFile
    ]);
};
module.exports["useBeforeUnload"] = $0a41942d2e8255bf$export$c0a586b329cae57d;

});

parcelRegister("dzqet", function(module, exports) {
var $b9ba7ab256cbc974$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["NOTION"] = "NOTION";
    ContentType["MIRO"] = "MIRO";
    ContentType["HTML"] = "HTML";
    ContentType["MURAL"] = "MURAL";
    return ContentType;
}({});
module.exports["ContentType"] = $b9ba7ab256cbc974$export$e2e108cbe2e4f865;

});

parcelRegister("6L3SK", function(module, exports) {

let $4eba24c30f415f45$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4eba24c30f415f45$var$load("6wr18"),
    $4eba24c30f415f45$var$load("9pso5"),
    $4eba24c30f415f45$var$load("5uN9h"),
    $4eba24c30f415f45$var$load("7MlKm"),
    $4eba24c30f415f45$var$load("hhss7"),
    $4eba24c30f415f45$var$load("kHOMt"),
    $4eba24c30f415f45$var$load("ffEVr"),
    $4eba24c30f415f45$var$load("7EorR"),
    $4eba24c30f415f45$var$load("Wowvf"),
    $4eba24c30f415f45$var$load("cRtGo"),
    $4eba24c30f415f45$var$load("9JWXo")
]).then(()=>parcelRequire('hSRPs'));

});

parcelRegister("f8AFM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jmjWc = parcelRequire("jmjWc");


var $5IN3L = parcelRequire("5IN3L");


var $dzqet = parcelRequire("dzqet");


const $123d8cc31f005f3d$var$ImportContentModalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "CsuHF",
    name: "ImportContentModalLoader",
    loader: async ()=>(await (parcelRequire("iSGhg"))).ImportContentModal
});
const $123d8cc31f005f3d$export$cf1f5228a529b27e = ()=>{
    const [importContentState, importContentActions] = (0, $5IN3L.useImportContentStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const makeCardClickHandler = (contentType)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'importContentCard',
                    source: 'importContentModal',
                    attributes: {
                        contentType: contentType
                    }
                }
            }).fire();
            importContentActions.setShowImportContentModal(false);
            importContentActions.setContentType(contentType);
            importContentActions.setShouldRenderDrawer(true);
            importContentActions.setShowImportContentDrawer(true);
        };
    return importContentState.shouldRenderModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($123d8cc31f005f3d$var$ImportContentModalLoader, {
        shouldRender: importContentState.showImportContentModal,
        onClose: ()=>importContentActions.setShowImportContentModal(false),
        onMiroClick: makeCardClickHandler((0, $dzqet.ContentType).MIRO),
        onNotionClick: makeCardClickHandler((0, $dzqet.ContentType).NOTION),
        onFileImportClick: makeCardClickHandler((0, $dzqet.ContentType).HTML),
        onMuralClick: makeCardClickHandler((0, $dzqet.ContentType).MURAL)
    }) : null;
};
module.exports["ConditionalImportContentModal"] = $123d8cc31f005f3d$export$cf1f5228a529b27e;

});

parcelRegister("iSGhg", function(module, exports) {

let $dbee108b1367905f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dbee108b1367905f$var$load("6wr18"),
    $dbee108b1367905f$var$load("ffEVr"),
    $dbee108b1367905f$var$load("hhss7"),
    $dbee108b1367905f$var$load("hX5aL")
]).then(()=>parcelRequire('c6LMF'));

});

parcelRegister("gKGjM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $fNJG8 = parcelRequire("fNJG8");


var $jh864 = parcelRequire("jh864");


var $ccHMk = parcelRequire("ccHMk");


var $5IN3L = parcelRequire("5IN3L");

const $02de2c54d3c44def$var$i18n = (0, $aXWIB.defineMessages)({
    buttonText: {
        id: "import-content.button.text",
        defaultMessage: "Import from other tools"
    }
});
const $02de2c54d3c44def$export$b0d230bf69c0838c = ({ isMenuButton: isMenuButton = true, closePopup: closePopup })=>{
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, importContentActions] = (0, $5IN3L.useImportContentStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                source: 'importContentButton'
            }
        }).fire();
        importContentActions.setShouldRenderModal(true);
        importContentActions.setShowImportContentModal(true);
        closePopup?.('import content clicked');
    };
    return isMenuButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jh864.ButtonMenuItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fNJG8))), {
            label: "",
            color: "currentColor"
        }),
        onClick: handleClick,
        testId: "import-content-menu-button-nav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $02de2c54d3c44def$var$i18n.buttonText)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: handleClick,
        appearance: "primary",
        testId: "import-content-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $02de2c54d3c44def$var$i18n.buttonText));
};
module.exports["ImportContentButton"] = $02de2c54d3c44def$export$b0d230bf69c0838c;

});

parcelRegister("fNJG8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c02a973e1b80a41efb48b80326ffc315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b80edd69ce46ac6c$var$_react = $b80edd69ce46ac6c$var$_interopRequireDefault((parcelRequire("42omo")));

var $b80edd69ce46ac6c$var$_baseNew = $b80edd69ce46ac6c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b80edd69ce46ac6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b80edd69ce46ac6c$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $b80edd69ce46ac6c$var$_react.default.createElement($b80edd69ce46ac6c$var$_baseNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$b80edd69ce46ac6c$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $b80edd69ce46ac6c$var$_default = module.exports.default = $b80edd69ce46ac6c$var$CloudArrowUpIcon;

});

parcelRegister("jh864", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8njHX = parcelRequire("8njHX");


var $jvL0g = parcelRequire("jvL0g");

const $bf400a28e0f66299$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jvL0g.MenuListItem), {
        ref: listItemRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8njHX.MenuItemBase), {
        testId: testId,
        description: description,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        isDisabled: isDisabled,
        /**
     * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
     * so they aren't rendered in the disabled state.
     */ actions: isDisabled ? undefined : actions,
        actionsOnHover: isDisabled ? undefined : actionsOnHover,
        onClick: onClick,
        ariaControls: ariaControls,
        ariaExpanded: ariaExpanded,
        ariaHasPopup: ariaHasPopup,
        isSelected: isSelected,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
});
module.exports["ButtonMenuItem"] = $bf400a28e0f66299$export$6dc09b7c0ec1dfcd;

});

parcelRegister("lfopc", function(module, exports) {
$parcel$export(module.exports, "ConditionalSingleImportModal", () => (parcelRequire("l1elF")).ConditionalSingleImportModal);
$parcel$export(module.exports, "openSingleImportModal", () => (parcelRequire("l1elF")).openSingleImportModal);

var $l1elF = parcelRequire("l1elF");


});

parcelRegister("l1elF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");

const $2d0a0b5daed038e9$var$listeners = new Set();
const $2d0a0b5daed038e9$export$c880e43fcffc4ee6 = ()=>{
    $2d0a0b5daed038e9$var$listeners.forEach((listener)=>listener());
};
const $2d0a0b5daed038e9$var$useSingleImportModalState = ()=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const handleOpen = ()=>{
            setIsOpen(true);
        };
        $2d0a0b5daed038e9$var$listeners.add(handleOpen);
        return ()=>{
            $2d0a0b5daed038e9$var$listeners.delete(handleOpen);
        };
    }, []);
    const closeModal = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    return [
        isOpen,
        closeModal
    ];
};

// Modal component
const $2d0a0b5daed038e9$var$SingleImportModalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Q_fZz",
    name: "SingleImportModalLoader",
    loader: async ()=>(await (parcelRequire("eDXiG"))).SingleImportModal
});
const $2d0a0b5daed038e9$export$c2504f474bd7d2f8 = ()=>{
    const [isOpen, closeModal] = $2d0a0b5daed038e9$var$useSingleImportModalState();
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2d0a0b5daed038e9$var$SingleImportModalLoader, {
        isOpen: isOpen,
        onClose: closeModal
    }) : null;
};
module.exports["openSingleImportModal"] = $2d0a0b5daed038e9$export$c880e43fcffc4ee6;
module.exports["ConditionalSingleImportModal"] = $2d0a0b5daed038e9$export$c2504f474bd7d2f8;

});

parcelRegister("eDXiG", function(module, exports) {

let $aa92b50291442957$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa92b50291442957$var$load("6wr18"),
    $aa92b50291442957$var$load("ffEVr"),
    $aa92b50291442957$var$load("hhss7"),
    $aa92b50291442957$var$load("8XUdf")
]).then(()=>parcelRequire('5WMB6'));

});

parcelRegister("gCDQT", function(module, exports) {

let $c19f1bc5691dea06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c19f1bc5691dea06$var$load("3R2Cd"),
    $c19f1bc5691dea06$var$load("2lYTs"),
    $c19f1bc5691dea06$var$load("2tuEe"),
    $c19f1bc5691dea06$var$load("9ijrN"),
    $c19f1bc5691dea06$var$load("hhss7"),
    $c19f1bc5691dea06$var$load("5NQgH"),
    $c19f1bc5691dea06$var$load("3Mspc"),
    $c19f1bc5691dea06$var$load("jfFQG")
]).then(()=>parcelRequire('72dQ5'));

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("b6DNq", function(module, exports) {

let $815f1feb04272314$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $815f1feb04272314$var$load("favdH"),
    $815f1feb04272314$var$load("dIKKx")
]).then(()=>parcelRequire('eYRFW'));

});

parcelRegister("aOp12", function(module, exports) {

let $7df1fa848f3b84e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7df1fa848f3b84e9$var$load("52dqm").then(()=>parcelRequire('3zSMJ'));

});

parcelRegister("5BRIl", function(module, exports) {

let $415a12fd4bf29e8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $415a12fd4bf29e8c$var$load("favdH"),
    $415a12fd4bf29e8c$var$load("gIOIL")
]).then(()=>parcelRequire('gLUng'));

});

parcelRegister("awHil", function(module, exports) {

let $7a9e7a04c0f6bef2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7a9e7a04c0f6bef2$var$load("3Mspc"),
    $7a9e7a04c0f6bef2$var$load("7TbZ2"),
    $7a9e7a04c0f6bef2$var$load("6wr18"),
    $7a9e7a04c0f6bef2$var$load("fjOTL"),
    $7a9e7a04c0f6bef2$var$load("ffEVr"),
    $7a9e7a04c0f6bef2$var$load("ehu5c")
]).then(()=>parcelRequire('kfmcq'));

});

parcelRegister("8AKrx", function(module, exports) {

var $69QGC = parcelRequire("69QGC");

var $fOoLf = parcelRequire("fOoLf");


var $dIgcq = parcelRequire("dIgcq");


var $biOtS = parcelRequire("biOtS");


var $iuZ4N = parcelRequire("iuZ4N");





var $2RNw9 = parcelRequire("2RNw9");

var $150tu = parcelRequire("150tu");

var $lRCxi = parcelRequire("lRCxi");

var $aHsHn = parcelRequire("aHsHn");


var $hYAxW = parcelRequire("hYAxW");


var $1Hbkf = parcelRequire("1Hbkf");

const $54349ac24c29d21a$var$MAX_FEATURE_VISIT_COUNT = 3;
const $54349ac24c29d21a$export$da8724bcb6526688 = 'crossJoinNudgesV3';
const $54349ac24c29d21a$export$49a8cf368338c69c = async ({ userId: userId, cloudId: cloudId, getMSRNudgeRecommendations: getMSRNudgeRecommendations })=>{
    const cachedUserIsTooNew = (0, $hYAxW.withEligibilityCache)('user_is_too_new', (0, $aHsHn.isUserTooNew), 1);
    if ((0, $1Hbkf.getFeatureVisitedCount)($54349ac24c29d21a$export$da8724bcb6526688) >= $54349ac24c29d21a$var$MAX_FEATURE_VISIT_COUNT) return {
        ineligibilityReason: 'FEATURE_VISITED_COUNT_MAXED_OUT'
    };
    if ((0, $1Hbkf.isUserOptedOut)($54349ac24c29d21a$export$da8724bcb6526688)) return {
        ineligibilityReason: 'USER_HAS_OPTED_OUT'
    };
    if (await (0, $lRCxi.isSiteOptedOut)(cloudId)) return {
        ineligibilityReason: 'SITE_OPTED_OUT'
    };
    if (await (0, $2RNw9.hasAccessToProduct)('jira-software', cloudId)) return {
        ineligibilityReason: 'ALREADY_HAVE_ACCESS'
    };
    if (await cachedUserIsTooNew(cloudId, userId, 'confluence_first_active')) return {
        ineligibilityReason: 'USER_IS_TOO_NEW'
    };
    const collaborators = await (0, $69QGC.getUsersFromCollaborationGraph)('crossJoinNudgesV3', cloudId, userId);
    if (collaborators === undefined || collaborators.length === 0) return {
        ineligibilityReason: 'NO_COLLABORATORS_FOUND'
    };
    const collaboratorsWithJiraAccess = await (0, $fOoLf.getCollaboratorsWithJiraAccess)(cloudId, collaborators);
    if (collaboratorsWithJiraAccess.length === 0) return {
        ineligibilityReason: 'COLLABORATORS_HAVE_NO_ACCESS'
    };
    if (!await (0, $iuZ4N.canUserRequestAccess)('jira-software', cloudId)) return {
        ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
    };
    if (!await (0, $150tu.isSite7DaysOld)('jira-software', cloudId)) return {
        ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
    };
    const recommendations = await getMSRNudgeRecommendations();
    if (!recommendations.includes('cjn-conf-jira-v3')) return {
        ineligibilityReason: 'MSR_NUDGE_NOT_RECOMMENDED'
    };
    return {
        ineligibilityReason: null,
        collaborators: collaboratorsWithJiraAccess
    };
};

























const $15b4e34a7ce1da70$var$MAX_FEATURE_VISIT_COUNT = 3;
const $15b4e34a7ce1da70$export$6353fe5db4bd7dca = 'crossJoinNudgesConfluenceToJpd';
const $15b4e34a7ce1da70$export$8916d0e9bd8973b7 = async (cloudId, userId)=>{
    const cachedUserIsTooNew = (0, $hYAxW.withEligibilityCache)('user_is_too_new', (0, $aHsHn.isUserTooNew), 1);
    if ((0, $1Hbkf.getFeatureVisitedCount)($15b4e34a7ce1da70$export$6353fe5db4bd7dca) >= $15b4e34a7ce1da70$var$MAX_FEATURE_VISIT_COUNT) return {
        eligible: false,
        ineligibilityReason: 'FEATURE_VISITED_COUNT_MAXED_OUT'
    };
    if ((0, $1Hbkf.isUserOptedOut)($15b4e34a7ce1da70$export$6353fe5db4bd7dca)) return {
        eligible: false,
        ineligibilityReason: 'USER_HAS_OPTED_OUT'
    };
    if (await (0, $lRCxi.isSiteOptedOut)(cloudId)) return {
        eligible: false,
        ineligibilityReason: 'SITE_OPTED_OUT'
    };
    if (await (0, $2RNw9.hasAccessToProduct)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'ALREADY_HAVE_ACCESS'
    };
    if (await cachedUserIsTooNew(cloudId, userId, 'confluence_first_active')) return {
        eligible: false,
        ineligibilityReason: 'USER_IS_TOO_NEW'
    };
    if (!await (0, $150tu.isSite7DaysOld)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
    };
    if (!await (0, $iuZ4N.canUserRequestAccess)('jira-product-discovery', cloudId)) return {
        eligible: false,
        ineligibilityReason: 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
    };
    return {
        eligible: true
    };
};


const $3e82bea0d95824c0$export$9d305ebad2a9218a = async ({ cloudId: cloudId, userId: userId, displayName: displayName, flags: flags, createAnalyticsEvent: createAnalyticsEvent, push: push, formatMessage: formatMessage, getMSRNudgeRecommendations: getMSRNudgeRecommendations })=>{
    const analytics = (0, $biOtS.getExperimentAnalytics)((0, $54349ac24c29d21a$export$da8724bcb6526688), createAnalyticsEvent);
    try {
        if (!userId || await (0, $1Hbkf.isFeatureVisited)((0, $54349ac24c29d21a$export$da8724bcb6526688))) return;
        const response = await (0, $54349ac24c29d21a$export$49a8cf368338c69c)({
            userId: userId,
            cloudId: cloudId,
            getMSRNudgeRecommendations: getMSRNudgeRecommendations
        });
        if (response.ineligibilityReason === null) {
            await (0, $dIgcq.showNudgeFlag)({
                product: 'jira-software',
                integration: (0, $54349ac24c29d21a$export$da8724bcb6526688),
                userId: userId,
                displayName: displayName,
                cloudId: cloudId,
                collaborators: response.collaborators,
                createAnalyticsEvent: createAnalyticsEvent,
                flags: flags,
                pushRoute: push,
                formatMessage: formatMessage
            });
            (0, $1Hbkf.increaseFeatureVisitedCount)((0, $54349ac24c29d21a$export$da8724bcb6526688));
            // this is used in the eligibility check for loom nudge
            await (0, $hYAxW.setHasSeenNudgeInLast7Days)();
        } else if (response.ineligibilityReason === 'SITE_OPTED_OUT') (0, $biOtS.fireSiteOptedOutAnalytics)(analytics);
        else if (response.ineligibilityReason === 'MSR_NUDGE_NOT_RECOMMENDED') (0, $biOtS.fireMsrNotRecommendedAnalytics)(analytics, 'cjn-conf-jira-v3');
    } catch (error) {
        (0, $biOtS.fireExperimentError)(analytics, error);
    }
};
const $3e82bea0d95824c0$export$db3bc6af881f6bd0 = async ({ cloudId: cloudId, userId: userId, createAnalyticsEvent: createAnalyticsEvent, getMSRNudgeRecommendations: getMSRNudgeRecommendations })=>{
    const analytics = (0, $biOtS.getExperimentAnalytics)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca), createAnalyticsEvent);
    try {
        if (!userId) return false;
        if (await (0, $1Hbkf.isFeatureVisited)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca))) return false;
        const eligibilityResponse = await (0, $15b4e34a7ce1da70$export$8916d0e9bd8973b7)(cloudId, userId);
        if (!eligibilityResponse.eligible) {
            if (eligibilityResponse.ineligibilityReason === 'SITE_OPTED_OUT') (0, $biOtS.fireSiteOptedOutAnalytics)(analytics);
            return false;
        }
        const recommendations = await getMSRNudgeRecommendations();
        if (!recommendations.includes('cjn-conf-jpd')) {
            (0, $biOtS.fireMsrNotRecommendedAnalytics)(analytics, 'cjn-conf-jpd');
            return false;
        }
        return true;
    } catch (error) {
        (0, $biOtS.fireExperimentError)(analytics, error);
        return false;
    }
};
const $3e82bea0d95824c0$export$2cec488374560b5c = async ({ cloudId: cloudId, userId: userId, displayName: displayName, flags: flags, createAnalyticsEvent: createAnalyticsEvent, push: push, formatMessage: formatMessage })=>{
    const analytics = (0, $biOtS.getExperimentAnalytics)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca), createAnalyticsEvent);
    try {
        if (!userId) return;
        const collaborators = await (0, $69QGC.getUsersFromCollaborationGraph)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca), cloudId, userId);
        const collaboratorsOnJpd = await (0, $fOoLf.getUsersWithProductAccess)('jira-product-discovery', cloudId, collaborators);
        await (0, $dIgcq.showNudgeFlag)({
            product: 'jira-product-discovery',
            integration: (0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca),
            userId: userId,
            displayName: displayName,
            cloudId: cloudId,
            collaborators: collaboratorsOnJpd,
            createAnalyticsEvent: createAnalyticsEvent,
            flags: flags,
            pushRoute: push,
            formatMessage: formatMessage
        });
        (0, $1Hbkf.increaseFeatureVisitedCount)((0, $15b4e34a7ce1da70$export$6353fe5db4bd7dca));
        // this is used in the eligibility check for loom nudge
        await (0, $hYAxW.setHasSeenNudgeInLast7Days)();
    } catch (error) {
        (0, $biOtS.fireExperimentError)(analytics, error);
    }
};
module.exports["triggerJiraCrossJoinNudge"] = $3e82bea0d95824c0$export$9d305ebad2a9218a;
module.exports["checkJpdCrossJoinNudgeEligibility"] = $3e82bea0d95824c0$export$db3bc6af881f6bd0;
module.exports["showJpdCrossJoinNudge"] = $3e82bea0d95824c0$export$2cec488374560b5c;

});

parcelRegister("69QGC", function(module, exports) {
const $49e5b045f74dcd7a$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $49e5b045f74dcd7a$export$f757fae6e9facd6f = async (integration, cloudId, userId)=>{
    const payload = {
        context: {
            contextType: integration,
            principalId: userId,
            siteId: cloudId
        },
        modelRequestParams: {
            experience: 'CgUserNearbyUser'
        },
        expanded: true,
        maxNumberOfResults: $49e5b045f74dcd7a$var$COLLABORATION_GRAPH_MAX_RESULTS,
        userId: userId
    };
    const response = await fetch('/gateway/api/collaboration/v1/collaborationgraph/user/user', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    const result = (await response.json())?.collaborationGraphEntities?.filter((en)=>en?.userProfile !== undefined && en?.userProfile?.account_type !== 'app' && en?.userProfile?.account_status !== 'deactivated' && en?.userProfile?.account_status !== 'deleted').map(({ userProfile: { account_id: account_id, name: name, picture: picture } })=>({
            id: account_id,
            name: name,
            avatar: picture
        }));
    return result;
};
module.exports["getUsersFromCollaborationGraph"] = $49e5b045f74dcd7a$export$f757fae6e9facd6f;

});

parcelRegister("fOoLf", function(module, exports) {
const $237583ee60417350$export$8db0f1e8ecc00a3f = async (cloudId, collaborators)=>{
    const accountIds = collaborators.map((c)=>c.id);
    const response = await fetch('/gateway/api/growth/cross-join-nudges-v3/get-permitted-jira-users', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cloudId: cloudId,
            accountIds: accountIds
        })
    });
    const returnedAccountIds = await response.json();
    return collaborators.filter((c)=>returnedAccountIds.includes(c.id));
};
const $237583ee60417350$export$a68fadaa3a8b5e25 = async (product, cloudId, collaborators)=>{
    const response = await fetch('/gateway/api/growth/invite-on-link-insert/get-invitees', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: collaborators.map((c)=>c.id)
        })
    });
    const returnedAccountIds = await response.json();
    return collaborators.filter((c)=>!returnedAccountIds.includes(c.id));
};
module.exports["getCollaboratorsWithJiraAccess"] = $237583ee60417350$export$8db0f1e8ecc00a3f;
module.exports["getUsersWithProductAccess"] = $237583ee60417350$export$a68fadaa3a8b5e25;

});

parcelRegister("dIgcq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4QLH5 = parcelRequire("4QLH5");

var $8YEMg = parcelRequire("8YEMg");




var $aXWIB = parcelRequire("aXWIB");


var $eCEXz = parcelRequire("eCEXz");


var $a3fRD = parcelRequire("a3fRD");


var $2Nwuj = parcelRequire("2Nwuj");

const $5bc94f32b32b3a52$export$2a1baa97ca79d572 = {
    confluence: 'Confluence',
    jira: 'Jira',
    'jira-software': 'Jira',
    'jira-product-discovery': 'Jira Product Discovery',
    loom: 'Loom'
};
const $5bc94f32b32b3a52$export$44fea6589b7ddc92 = (product)=>$5bc94f32b32b3a52$export$2a1baa97ca79d572[product];






var $keVvA = parcelRequire("keVvA");


var $4yBJM = parcelRequire("4yBJM");


var $4opcN = parcelRequire("4opcN");




function $88141116575c9211$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $42omo.useState)({});
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        let isMounted = true;
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                setIsLoading(true);
                const module = await $88141116575c9211$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                if (isMounted) setMessages(newMessages);
            } catch (// eslint-disable-next-line no-unused-vars
            e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                if (isMounted) setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
        return ()=>{
            isMounted = false;
        };
    }, [
        locale
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}


























function $88141116575c9211$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("kVIRg"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("49i1r"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("dasEj"));
        case 'en-GB':
            return (parcelRequire("lC97I"));
        case 'en-AU':
        case 'en-US':
        case 'en':
            return Promise.resolve((parcelRequire("4opcN")));
        case 'en-ZZ':
            return (parcelRequire("3KIQf"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("gzQK5"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("ePDTL"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("jl7HU"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("c585o"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("jAnnr"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("4HVkJ"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("dcU0x"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("iO7I3"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("jat2x"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("cekPs"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("6U9LK"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("gVZfP"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("emNuY"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("17t4T"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("hOImN"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("1Kgrq"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("bybL2"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("hzFW1"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("kjxkN"));
        default:
            return Promise.resolve((parcelRequire("4opcN")));
    }
}


























function $88141116575c9211$export$65a15453632bd60b(locale) {
    // Normalize locale to match global-shortcuts format
    const normalizedLocale = locale.replace('_', '-');
    const languageLocale = normalizedLocale.split(/[-_]/)[0] || 'en';
    switch(normalizedLocale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("7ttEc"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("7OHuB"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("jpB0s"));
        case 'en-GB':
            return (parcelRequire("jCWwP"));
        case 'en-AU':
        case 'en-US':
        case 'en':
            return Promise.resolve((parcelRequire("4yBJM")));
        case 'en-ZZ':
            return (parcelRequire("lHMT3"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("hJ9kV"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("5rwHI"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("9qEKd"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("a7JZv"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("aD7ie"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("bKGp5"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("c4Nwk"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("6ZdFN"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("kbvK1"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("cRhRj"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("ij8LW"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("4AdNi"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("46LQR"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("fcybv"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("clAdA"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("1Ixw1"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("f6Mq7"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("ak97t"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("glFbo"));
        default:
            // Fallback to language code if specific locale not found
            if (languageLocale === 'en') return Promise.resolve((parcelRequire("4yBJM")));
    }
    return Promise.resolve({
        default: {}
    });
}


// Merge default English messages at module level to avoid missing translation errors
const $a785c260fdcc781d$var$DEFAULT_MERGED_MESSAGES = {
    ...(0, $4yBJM.default),
    ...(0, $4opcN.default)
};
const $a785c260fdcc781d$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        // Normalize locale - Intl.Locale doesn't like underscores
        const normalizedLocale = locale.replace('_', '-');
        const finalLocale = new Intl.Locale(normalizedLocale).toString();
        // Fetch messages from both packages in parallel
        const [crossJoinNudgesModule, globalShortcutsModule] = await Promise.all([
            (0, $88141116575c9211$export$c08b58fa4727b0d2)(finalLocale).catch(()=>({
                    default: {}
                })),
            (0, $88141116575c9211$export$65a15453632bd60b)(finalLocale).catch(()=>({
                    default: {}
                }))
        ]);
        const crossJoinNudgesMessages = crossJoinNudgesModule.default || crossJoinNudgesModule;
        const globalShortcutsMessages = globalShortcutsModule.default || globalShortcutsModule;
        // Merge messages: cross-join-nudges messages take precedence over global-shortcuts
        // Start with defaults, then override with locale-specific messages
        const mergedMessages = {
            ...$a785c260fdcc781d$var$DEFAULT_MERGED_MESSAGES,
            ...globalShortcutsMessages,
            ...crossJoinNudgesMessages
        };
        return mergedMessages;
    } catch (// eslint-disable-next-line no-unused-vars
    e) {
        // If loading fails, return default messages
        return $a785c260fdcc781d$var$DEFAULT_MERGED_MESSAGES;
    }
};
const $a785c260fdcc781d$export$c5d7da1d3dca7da2 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $keVvA.default), {
        defaultMessages: $a785c260fdcc781d$var$DEFAULT_MERGED_MESSAGES,
        loaderFn: $a785c260fdcc781d$export$2b153a2030b0feb2
    }, children);
function $a785c260fdcc781d$export$2a4cd3780f93f2ef(Component) {
    return function WithLocalIntlComponent(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a785c260fdcc781d$export$c5d7da1d3dca7da2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props));
    };
}





const $b4eade39954d5e85$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    title: {
        id: "cross-join-nudges.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to {product}"
    },
    description: {
        id: "cross-join-nudges.request-access-error-flag.description-support-link",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>."
    }
});


const $972d0d1a08d63dad$var$SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $972d0d1a08d63dad$export$e1d0d64874873c8b = (0, $a785c260fdcc781d$export$2a4cd3780f93f2ef)(({ onDismiss: onDismiss, targetProduct: targetProduct, flagComponent: FlagComponent = (0, $eCEXz.default), ...props })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagComponent, {
        ...props,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        onDismissed: onDismiss,
        title: formatMessage((0, $b4eade39954d5e85$export$defe85febe8b728c).title, {
            product: (0, $5bc94f32b32b3a52$export$44fea6589b7ddc92)(targetProduct)
        }),
        description: formatMessage((0, $b4eade39954d5e85$export$defe85febe8b728c).description, {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: $972d0d1a08d63dad$var$SUPPORT_LINK
                }, chunks)
        })
    });
});

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $hQNhB = parcelRequire("hQNhB");





var $c6GJD = parcelRequire("c6GJD");





var $eXmBZ = parcelRequire("eXmBZ");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");








var $2Pg7f = parcelRequire("2Pg7f");


var $3gadb = parcelRequire("3gadb");

const $83a48c2a9ee27fa2$var$MAX_AVATARS_FEATURED_BOTTOM = 4;
const $83a48c2a9ee27fa2$var$MAX_AVATARS_FEATURED_TOP = 2;
const $83a48c2a9ee27fa2$export$29beada2d5f93289 = ({ position: position = 'bottom', data: data, ...props })=>{
    const maxAvatarCount = position === 'top' ? $83a48c2a9ee27fa2$var$MAX_AVATARS_FEATURED_TOP : $83a48c2a9ee27fa2$var$MAX_AVATARS_FEATURED_BOTTOM;
    const tooltipPosition = position;
    const { data: customData, overrides: customOverrides } = (0, $42omo.useMemo)(()=>$83a48c2a9ee27fa2$export$bc55c1ff86d63c4d({
            data: data,
            maxAvatarCount: maxAvatarCount
        }), [
        data,
        maxAvatarCount
    ]);
    const avatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        tooltipPosition: tooltipPosition,
        onMoreClick: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB))),
        ...props
    });
    return avatarGroup;
};
const $83a48c2a9ee27fa2$export$bc55c1ff86d63c4d = ({ data: users, maxAvatarCount: maxAvatarCount = $83a48c2a9ee27fa2$var$MAX_AVATARS_FEATURED_BOTTOM })=>{
    const lastFeaturedUser = maxAvatarCount - 1;
    const overflowUsers = users.slice(lastFeaturedUser);
    const overrides = {
        MoreIndicator: {
            render: (Component, componentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: overflowUsers.map((u)=>u.name).join(', '),
                    position: "top"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                    ...componentProps,
                    borderColor: "none",
                    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB)))
                }))
        }
    };
    return {
        overrides: overrides,
        data: users
    };
};




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $fVUfS = parcelRequire("fVUfS");

const $2ab564100a8568f0$var$styles = {
    button: "_11c8fhey _1reo15vq _18m915vq _1rjcze3t _18zrze3t _bfhksm61 _syaz13af _k48p1wq8 _p12f1w81 _9oik1r31 _1bnx8stv _jf4cnqa1"
};
const $2ab564100a8568f0$export$29d11c0fe2fc51d8 = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        onClick: onClick,
        xcss: $2ab564100a8568f0$var$styles.button
    }, children);
};





const $5299b9331331d488$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    title: {
        id: "cross-join-nudges.request-access-prompt-flag.title",
        defaultMessage: "Your team is now using {product}"
    },
    titleReminder: {
        id: "cross-join-nudges.request-access-prompt-flag.title-reminder",
        defaultMessage: "Your team is working in {product}"
    },
    titleNotInterested: {
        id: "cross-join-nudges.request-access-prompt-flag.title-not-interested",
        defaultMessage: "Your team is waiting for you in {product}"
    },
    descriptionJira: {
        id: "cross-join-nudges.request-access-prompt-flag.description-jira",
        defaultMessage: "Stay on top of your tasks, unify your project workflow and track your team progress in Jira."
    },
    joinButton: {
        id: "cross-join-nudges.request-access-prompt-flag.join-button",
        defaultMessage: "Join your team"
    },
    remindMeLaterButton: {
        id: "cross-join-nudges.request-access-prompt-flag.remind-me-later-button",
        defaultMessage: "Remind me later"
    },
    notInterestedButton: {
        id: "cross-join-nudges.request-access-prompt-flag.not-interested-button",
        defaultMessage: "Not interested"
    },
    titleJpdNudge: {
        id: "cross-join-nudges.request-access-prompt-flag.title-jpd-nudge",
        defaultMessage: "Join your team in using Jira Product Discovery"
    },
    titleJiraNudgeMsr: {
        id: "cross-join-nudges.request-access-prompt-flag.title-jira-nudge",
        defaultMessage: "Join your team in using Jira"
    },
    descriptionJpdNudge: {
        id: "cross-join-nudges.request-access-prompt-flag.description-jpd-nudge",
        defaultMessage: "Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery."
    },
    getStartedButton: {
        id: "cross-join-nudges.request-access-prompt-flag.get-started-button",
        defaultMessage: "Get started"
    },
    doNotShowAgainButton: {
        id: "cross-join-nudges.request-access-prompt-flag.do-not-show-again-button",
        defaultMessage: "Don't show again"
    },
    descriptionJiraGalaxia: {
        id: "cross-join-nudges.request-access-prompt-flag.description-jira-galaxia",
        defaultMessage: "Stay on top of your tasks, unify your space workflow and track your team progress in Jira."
    },
    titleJiraConfluenceMsrNudge: {
        id: "cross-join-nudges.common.request-access-prompt-flag.title-jira-confluence-msr-nudge",
        defaultMessage: "Join your team in using Confluence"
    },
    descriptionJiraConfluenceMsrNudgeNoCollaborators: {
        id: "cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-no-collaborators",
        defaultMessage: "Create project pages to build a shared understanding for better decision-making."
    },
    descriptionJiraConfluenceMsrNudgeWithCollaborators: {
        id: "cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-with-collaborators",
        defaultMessage: "Organize team knowledge, capture ideas, and share requirements for your Jira projects. "
    },
    titleLoomNudge: {
        id: "cross-join-nudges.request-access-prompt-flag.title-loom-nudge",
        defaultMessage: "Join your team on Loom"
    },
    descriptionLoomNudge: {
        id: "cross-join-nudges.request-access-prompt-flag.description-loom-nudge",
        defaultMessage: "Use Loom videos to summarize pages and share information."
    }
});


const $ea34d206000e8fcb$var$messageLibrary = (()=>({
        crossJoinNudgesV3: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).joinButton,
            remindMeLaterButton: (0, $5299b9331331d488$export$defe85febe8b728c).remindMeLaterButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).notInterestedButton,
            descriptionWithCollaborators: (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJiraGalaxia : (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJira,
            descriptionWithoutCollaborators: (0, $c6GJD.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJiraGalaxia : (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJira,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).title,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleReminder,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleNotInterested
        },
        crossJoinNudgesConfluenceToJpd: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).getStartedButton,
            remindMeLaterButton: (0, $5299b9331331d488$export$defe85febe8b728c).remindMeLaterButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).doNotShowAgainButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJpdNudge,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJpdNudge,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge
        },
        crossJoinNudgesJiraToConfluence: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).getStartedButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).remindMeLaterButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJiraConfluenceMsrNudgeWithCollaborators,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJiraConfluenceMsrNudgeNoCollaborators,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).titleJiraConfluenceMsrNudge,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleJiraConfluenceMsrNudge,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleJiraConfluenceMsrNudge
        },
        crossJoinNudgesJiraToJpd: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).getStartedButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).remindMeLaterButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJpdNudge,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJpdNudge,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge
        },
        crossJoinNudgesConfluenceToJiraMsr: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).getStartedButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).remindMeLaterButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJira,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJira,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).titleJiraNudgeMsr,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleJiraNudgeMsr,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleJiraNudgeMsr
        },
        crossJoinNudgesConfluenceToJpdMsr: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).getStartedButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).doNotShowAgainButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJpdNudge,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJpdNudge,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleJpdNudge
        },
        crossJoinNudgesConfluenceToLoom: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).getStartedButton,
            remindMeLaterButton: (0, $5299b9331331d488$export$defe85febe8b728c).remindMeLaterButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).notInterestedButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionLoomNudge,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionLoomNudge,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).titleLoomNudge,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleLoomNudge,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleLoomNudge
        },
        invitedAppShortcuts: {
            ctaButton: (0, $5299b9331331d488$export$defe85febe8b728c).joinButton,
            optOutButton: (0, $5299b9331331d488$export$defe85febe8b728c).notInterestedButton,
            descriptionWithCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJira,
            descriptionWithoutCollaborators: (0, $5299b9331331d488$export$defe85febe8b728c).descriptionJira,
            title: (0, $5299b9331331d488$export$defe85febe8b728c).title,
            titleReminder: (0, $5299b9331331d488$export$defe85febe8b728c).titleReminder,
            titleNotInterested: (0, $5299b9331331d488$export$defe85febe8b728c).titleNotInterested
        }
    }))();
const $ea34d206000e8fcb$var$MAX_NUMBER_OF_COLLABORATORS = 10;
const $ea34d206000e8fcb$var$styles = {
    descriptionWrapper: "_1reoewfl _18m9ewfl _195gze3t _19pkze3t _otyru2gc"
};
const $ea34d206000e8fcb$export$5a4ad4945410eb2c = ({ integration: integration, collaborators: collaborators, descriptionWithCollaborators: descriptionWithCollaborators = null, targetProduct: // Can be supplied to override the description when there are multiple collaborators
targetProduct, viewCount: viewCount, onSubmit: onSubmit, onDismiss: onDismiss, onSnoozeAndDismiss: onSnoozeAndDismiss, onOptoutAndDismiss: onOptoutAndDismiss, flagComponent: FlagComponent = (0, $eCEXz.default), ...props })=>{
    const handleOnSubmit = (0, $42omo.useCallback)(async ()=>{
        await onSubmit();
    }, [
        onSubmit
    ]);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const messages = $ea34d206000e8fcb$var$messageLibrary[integration];
    const customFlagFooterProps = (0, $42omo.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB)))
                }
            ],
            linkComponent: ()=>{
                let secondCTA = null;
                if (viewCount === 1 && messages['remindMeLaterButton']) secondCTA = /*#__PURE__*/ $42omo.createElement((0, $2ab564100a8568f0$export$29d11c0fe2fc51d8), {
                    onClick: onSnoozeAndDismiss
                }, formatMessage(messages['remindMeLaterButton']));
                else if (viewCount > 1) secondCTA = /*#__PURE__*/ $42omo.createElement((0, $2ab564100a8568f0$export$29d11c0fe2fc51d8), {
                    onClick: onOptoutAndDismiss
                }, formatMessage(messages['optOutButton']));
                return /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                    alignInline: "start",
                    grow: "fill",
                    alignBlock: "center",
                    separator: "\xb7",
                    space: "space.150"
                }, /*#__PURE__*/ $42omo.createElement((0, $2ab564100a8568f0$export$29d11c0fe2fc51d8), {
                    onClick: handleOnSubmit
                }, formatMessage(messages['ctaButton'])), secondCTA);
            }
        }), [
        viewCount,
        handleOnSubmit,
        formatMessage,
        messages,
        onSnoozeAndDismiss,
        onOptoutAndDismiss
    ]);
    const customIcon = (0, $42omo.useMemo)(()=>{
        return collaborators.length > 0 ? /*#__PURE__*/ $42omo.createElement((0, $83a48c2a9ee27fa2$export$29beada2d5f93289), {
            position: "top",
            data: collaborators.slice(0, $ea34d206000e8fcb$var$MAX_NUMBER_OF_COLLABORATORS).map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle'
                })),
            boundariesElement: "scrollParent",
            size: "small"
        }) : /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            color: "var(--ds-icon-information, #357DE8)",
            label: ""
        });
    }, [
        collaborators
    ]);
    const title = viewCount === 0 ? messages['title'] : viewCount === 1 ? messages['titleReminder'] : messages['titleNotInterested'];
    const infoFlagTitle = formatMessage(title, {
        product: (0, $5bc94f32b32b3a52$export$44fea6589b7ddc92)(targetProduct)
    });
    const description = collaborators.length === 0 ? formatMessage(messages['descriptionWithoutCollaborators']) : descriptionWithCollaborators || formatMessage(messages['descriptionWithCollaborators']);
    return /*#__PURE__*/ $42omo.createElement(FlagComponent, {
        ...props,
        ...customFlagFooterProps,
        onDismissed: viewCount === 0 ? onDismiss : onSnoozeAndDismiss,
        title: infoFlagTitle,
        description: /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $ea34d206000e8fcb$var$styles.descriptionWrapper
        }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            as: "p",
            maxLines: 3
        }, description)),
        icon: customIcon
    });
};
const $ea34d206000e8fcb$export$9b8813c3601640da = (0, $a785c260fdcc781d$export$2a4cd3780f93f2ef)($ea34d206000e8fcb$export$5a4ad4945410eb2c);











var $3sFtD = parcelRequire("3sFtD");





const $c15a75c32a878fff$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    title: {
        id: "cross-join-nudges.request-access-success-flag.title",
        defaultMessage: "A request was sent to your admins"
    },
    description: {
        id: "cross-join-nudges.request-access-success-flag.description",
        defaultMessage: "You'll receive an email once they've reviewed it."
    }
});


const $eccd6d357c9d913e$export$567128fc1024c9cf = (0, $a785c260fdcc781d$export$2a4cd3780f93f2ef)(({ onDismiss: onDismiss, flagComponent: FlagComponent = (0, $eCEXz.default), ...props })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagComponent, {
        ...props,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            spacing: "spacious",
            label: "Success",
            color: "var(--ds-icon-success, #6A9A23)"
        }),
        onDismissed: onDismiss,
        title: formatMessage((0, $c15a75c32a878fff$export$defe85febe8b728c).title),
        description: formatMessage((0, $c15a75c32a878fff$export$defe85febe8b728c).description)
    });
});



var $9wGTI = parcelRequire("9wGTI");


var $lsxnT = parcelRequire("lsxnT");


var $1Hbkf = parcelRequire("1Hbkf");


var $biOtS = parcelRequire("biOtS");

const $5ef7c2e23b8af61a$var$crossJoinRoutes = {
    crossJoinNudgesV3: '/jira',
    crossJoinNudgesConfluenceToJpd: '/jira/projects'
};
const $5ef7c2e23b8af61a$export$e55a23675aaa8cd1 = async ({ product: product, integration: integration, userId: userId, displayName: displayName, cloudId: cloudId, collaborators: collaborators, createAnalyticsEvent: createAnalyticsEvent, flags: flags, pushRoute: pushRoute, formatMessage: formatMessage })=>{
    const featureVisitedCount = (0, $1Hbkf.getFeatureVisitedCount)(integration);
    const attributes = {
        collaborators: collaborators.length,
        userId: userId,
        featureVisitedCount: featureVisitedCount
    };
    const analytics = (0, $biOtS.getExperimentAnalytics)(integration, createAnalyticsEvent, {
        attributes: attributes
    });
    const dismiss = async (id, flags)=>{
        (0, $biOtS.fireFlagDismissed)(analytics);
        await flags.hideFlag(id);
    };
    const dismissAndSnooze = async (id, flags)=>{
        await dismiss(id, flags);
        (0, $biOtS.fireFlagSnoozed)(analytics);
        (0, $1Hbkf.snoozeFeatureFor30Days)(integration);
    };
    const dismissAndOptout = async (id, flags)=>{
        await dismiss(id, flags);
        (0, $biOtS.fireUserOptedOut)(analytics);
        (0, $1Hbkf.setUserOptedOut)(integration);
    };
    await flags.showFlag({
        customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ef7c2e23b8af61a$export$ef75ccc59458e1ea, {
                id: props.id,
                integration: integration,
                collaborators: collaborators,
                targetProduct: product,
                viewCount: featureVisitedCount,
                onDismiss: ()=>dismiss(props.id, flags),
                onSnoozeAndDismiss: ()=>dismissAndSnooze(props.id, flags),
                onOptoutAndDismiss: ()=>dismissAndOptout(props.id, flags),
                onSubmit: async ()=>{
                    try {
                        const nonContextualNote = (0, $9wGTI.fg)('twcg-1402-non-contextual-ra-note-gate') ? (0, $4QLH5.buildNonContextualNote)({
                            displayName: displayName ?? null,
                            targetProduct: product,
                            formatMessage: formatMessage
                        }) : undefined;
                        const accessStatus = await (0, $8YEMg.requestAccess)(product, 'confluence', integration, userId, cloudId, createAnalyticsEvent, nonContextualNote);
                        if (accessStatus === 'ACCESS_GRANTED' || accessStatus === 'ACCESS_EXISTS' || accessStatus === 'APPROVED_REQUEST_EXISTS') pushRoute($5ef7c2e23b8af61a$var$crossJoinRoutes[integration]);
                        else if (accessStatus === 'PENDING_REQUEST_CREATED' || accessStatus === 'PENDING_REQUEST_EXISTS') {
                            await flags.hideFlag(props.id);
                            await $5ef7c2e23b8af61a$export$fef8478a2c810f18(flags);
                        } else {
                            await flags.hideFlag(props.id);
                            await $5ef7c2e23b8af61a$export$dfa2148cdb92917d(flags, product);
                        }
                    } catch  {
                        await flags.hideFlag(props.id);
                        await $5ef7c2e23b8af61a$export$dfa2148cdb92917d(flags, product);
                    }
                    (0, $biOtS.fireJoinButtonClicked)(analytics);
                }
            })
    });
    (0, $biOtS.fireFlagShown)(analytics);
};
const $5ef7c2e23b8af61a$export$fef8478a2c810f18 = async (flags)=>{
    await flags.showFlag({
        customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eccd6d357c9d913e$export$567128fc1024c9cf), {
                id: props.id,
                onDismiss: ()=>flags.hideFlag(props.id)
            })
    });
};
const $5ef7c2e23b8af61a$export$dfa2148cdb92917d = async (flags, product)=>{
    await flags.showFlag({
        customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $972d0d1a08d63dad$export$e1d0d64874873c8b), {
                id: props.id,
                targetProduct: product,
                onDismiss: ()=>flags.hideFlag(props.id)
            })
    });
};
function $5ef7c2e23b8af61a$export$ef75ccc59458e1ea({ ...passThrough }) {
    const { useChoreographedRender: useChoreographedRender } = (0, $lsxnT.useChoreographerAssets)();
    const canShow = useChoreographedRender({
        messageId: 'cc-cross-join-nudge'
    });
    return canShow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ea34d206000e8fcb$export$9b8813c3601640da), passThrough) : null;
}
module.exports["showNudgeFlag"] = $5ef7c2e23b8af61a$export$e55a23675aaa8cd1;
module.exports["ChoreographerRequestAccessPromptFlag"] = $5ef7c2e23b8af61a$export$ef75ccc59458e1ea;
module.exports["showSuccessFlag"] = $5ef7c2e23b8af61a$export$fef8478a2c810f18;
module.exports["showErrorFlag"] = $5ef7c2e23b8af61a$export$dfa2148cdb92917d;

});

parcelRegister("4QLH5", function(module, exports) {

var $2IyA1 = parcelRequire("2IyA1");

const $d747d41c113c6170$export$ccdf4a6c54ceeae4 = ({ displayName: displayName, userEmail: userEmail, fullName: fullName, targetProduct: targetProduct, formatMessage: formatMessage })=>{
    const requestingUser = displayName || fullName || userEmail;
    const noteMessage = $d747d41c113c6170$export$72fea0d2e5e9a701(targetProduct);
    if (!noteMessage || !requestingUser) return undefined;
    const noteText = formatMessage(noteMessage, {
        requestingUser: requestingUser
    });
    return noteText;
};
const $d747d41c113c6170$export$72fea0d2e5e9a701 = (targetProduct)=>{
    switch(targetProduct){
        case 'jira-product-discovery':
            return (0, $2IyA1.nonContextualNoteMessages).jpdValueProp;
        case 'jira-software':
            return (0, $2IyA1.nonContextualNoteMessages).jiraValueProp;
        case 'loom':
            return (0, $2IyA1.nonContextualNoteMessages).loomValueProp;
        case 'confluence':
            return (0, $2IyA1.nonContextualNoteMessages).confluenceValueProp;
        default:
            return undefined;
    }
};
module.exports["buildNonContextualNote"] = $d747d41c113c6170$export$ccdf4a6c54ceeae4;

});

parcelRegister("8YEMg", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");

const $368e3dac27509b32$export$cd9e5995821603e1 = async (product, sourceProduct, integration, userId, cloudId, createAnalyticsEvent, nonContextualNote)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const experimentEligible = nonContextualNote && (0, $dh538.fg)('twcg-1402-non-contextual-ra-note-gate');
    const nonContextualNoteCohort = experimentEligible ? (0, $c6GJD.default).getExperimentValue('twcg-1402-non-contextual-ra-note', 'cohort', 'not-enrolled') : undefined;
    const nonContextualNoteEnabled = nonContextualNoteCohort === 'variation';
    try {
        const response = await fetch('/gateway/api/invitations/v1/access-requests/request', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource,
                ...nonContextualNoteEnabled && {
                    note: nonContextualNote
                },
                metadata: {
                    touchpoint: 'Crossjoin Nudge',
                    sourceProduct: sourceProduct
                }
            })
        });
        const accessRequestResponse = await response.json();
        const { results: results } = accessRequestResponse;
        const result = results[resource];
        const analyticsAttributes = {
            userId: userId,
            products: [
                product
            ],
            inviteResult: [
                {
                    resourceAri: resource,
                    status: result
                }
            ],
            integration: integration,
            ...experimentEligible && {
                nonContextualNoteCohort: nonContextualNoteCohort
            }
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'requested',
                actionSubject: 'productAccess',
                source: integration,
                attributes: analyticsAttributes
            }
        }).fire();
        return result;
    } catch (error) {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'requestAccess',
                source: integration,
                attributes: {
                    message: String(error),
                    details: {
                        ...error || {}
                    }
                }
            }
        }).fire();
        throw error;
    }
};
module.exports["requestAccess"] = $368e3dac27509b32$export$cd9e5995821603e1;

});

parcelRegister("4yBJM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $898892faf0a0a598$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $898892faf0a0a598$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': 'Analytics',
    'navigation.global-shortcuts.apps.assets': 'Assets',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Company Hub',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.customer-service-management': 'Customer Service Management',
    'navigation.global-shortcuts.apps.feedback': 'Feedback',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Goals',
    'navigation.global-shortcuts.apps.home': 'Home',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Projects',
    'navigation.global-shortcuts.apps.projects-galaxia': 'Spaces',
    'navigation.global-shortcuts.apps.studio': 'Studio',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Teams',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.error.description': 'Refresh the page and try again',
    'navigation.global-shortcuts.error.header': "We couldn\u2019t load the shortcut for {menuId}",
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Open external link icon',
    'navigation.global-shortcuts.shortcut-action.open-menu-label': 'open menu',
    'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
    'navigation.global-shortcuts.view-all-apps.label': 'View all apps'
};

});

parcelRegister("4opcN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2f37d5078b127d0b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $4a63a3b5bacb8bda$export$2e2bcd8739ae039 = {
    'cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-no-collaborators': 'Create project pages to build a shared understanding for better decision-making.',
    'cross-join-nudges.common.request-access-prompt-flag.description-jira-confluence-msr-nudge-with-collaborators': 'Organize team knowledge, capture ideas, and share requirements for your Jira projects.',
    'cross-join-nudges.common.request-access-prompt-flag.title-jira-confluence-msr-nudge': 'Join your team in using Confluence',
    'cross-join-nudges.invited-app-shortcuts.confluence': 'Confluence',
    'cross-join-nudges.invited-app-shortcuts.invited-lozenge': 'Invited',
    'cross-join-nudges.invited-app-shortcuts.jira': 'Jira',
    'cross-join-nudges.invited-app-shortcuts.popup-accept-invite-button': 'Accept invite',
    'cross-join-nudges.invited-app-shortcuts.popup-collaborators-tooltip': '{numberOfCollaborators} more {numberOfCollaborators, plural, one {teammate} other {teammates}} are using {app}',
    'cross-join-nudges.invited-app-shortcuts.popup-main-text-with-collaborators': "You're invited to join your team",
    'cross-join-nudges.invited-app-shortcuts.popup-main-text-without-collaborators': "Don't lose access, accept invite now",
    'cross-join-nudges.non-contextual-note.confluence-value-prop': '{requestingUser} needs Confluence access to collaborate on pages and whiteboards.',
    'cross-join-nudges.non-contextual-note.jira-value-prop': '{requestingUser} needs Jira access to plan and track work.',
    'cross-join-nudges.non-contextual-note.jpd-value-prop': '{requestingUser} needs Jira Product Discovery access to prioritize ideas and create roadmaps.',
    'cross-join-nudges.non-contextual-note.loom-value-prop': '{requestingUser} needs Loom access to create and edit videos.',
    'cross-join-nudges.request-access-error-flag.description-support-link': "Try again in a few minutes. If you still aren't able to join, <a>contact support</a>.",
    'cross-join-nudges.request-access-error-flag.title': "We couldn't add you to {product}",
    'cross-join-nudges.request-access-prompt-flag.description-jira': 'Stay on top of your tasks, unify your project workflow and track your team progress in Jira.',
    'cross-join-nudges.request-access-prompt-flag.description-jira-galaxia': 'Stay on top of your tasks, unify your space workflow and track your team progress in Jira.',
    'cross-join-nudges.request-access-prompt-flag.description-jpd-nudge': 'Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery.',
    'cross-join-nudges.request-access-prompt-flag.description-loom-nudge': 'Use Loom videos to summarize pages and share information.',
    'cross-join-nudges.request-access-prompt-flag.do-not-show-again-button': "Don't show again",
    'cross-join-nudges.request-access-prompt-flag.get-started-button': 'Get started',
    'cross-join-nudges.request-access-prompt-flag.join-button': 'Join your team',
    'cross-join-nudges.request-access-prompt-flag.not-interested-button': 'Not interested',
    'cross-join-nudges.request-access-prompt-flag.remind-me-later-button': 'Remind me later',
    'cross-join-nudges.request-access-prompt-flag.title': 'Your team is now using {product}',
    'cross-join-nudges.request-access-prompt-flag.title-jira-nudge': 'Join your team in using Jira',
    'cross-join-nudges.request-access-prompt-flag.title-jpd-nudge': 'Join your team in using Jira Product Discovery',
    'cross-join-nudges.request-access-prompt-flag.title-loom-nudge': 'Join your team on Loom',
    'cross-join-nudges.request-access-prompt-flag.title-not-interested': 'Your team is waiting for you in {product}',
    'cross-join-nudges.request-access-prompt-flag.title-reminder': 'Your team is working in {product}',
    'cross-join-nudges.request-access-success-flag.description': "You'll receive an email once they've reviewed it.",
    'cross-join-nudges.request-access-success-flag.title': 'A request was sent to your admins'
};


var $2f37d5078b127d0b$export$2e2bcd8739ae039 = (0, $4a63a3b5bacb8bda$export$2e2bcd8739ae039);

});

parcelRegister("kVIRg", function(module, exports) {

let $f3cbed6d618b220c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3cbed6d618b220c$var$load("aIwO0").then(()=>parcelRequire('kJXhH'));

});

parcelRegister("49i1r", function(module, exports) {

let $3055fb8d838d35a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3055fb8d838d35a1$var$load("iwseV").then(()=>parcelRequire('e9Wyv'));

});

parcelRegister("dasEj", function(module, exports) {

let $99626eace46d7bc5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99626eace46d7bc5$var$load("eh9w8").then(()=>parcelRequire('bcTDG'));

});

parcelRegister("lC97I", function(module, exports) {

let $fbc43951974296c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fbc43951974296c9$var$load("3eWGu").then(()=>parcelRequire('5UXdT'));

});

parcelRegister("3KIQf", function(module, exports) {

let $2bb87398117f81ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bb87398117f81ac$var$load("8jVst").then(()=>parcelRequire('kaCr9'));

});

parcelRegister("gzQK5", function(module, exports) {

let $c118d3c33f76afeb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c118d3c33f76afeb$var$load("hNk7k").then(()=>parcelRequire('guYPm'));

});

parcelRegister("ePDTL", function(module, exports) {

let $acc4c71d953145e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $acc4c71d953145e3$var$load("arXo9").then(()=>parcelRequire('e65rL'));

});

parcelRegister("jl7HU", function(module, exports) {

let $e145f4faabedcc3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e145f4faabedcc3c$var$load("yuLnu").then(()=>parcelRequire('e1RZ8'));

});

parcelRegister("c585o", function(module, exports) {

let $8cbc396421eb872f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cbc396421eb872f$var$load("2pQv8").then(()=>parcelRequire('an7BE'));

});

parcelRegister("jAnnr", function(module, exports) {

let $e4238353f237f732$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4238353f237f732$var$load("jGBo1").then(()=>parcelRequire('hPdO5'));

});

parcelRegister("4HVkJ", function(module, exports) {

let $36d7a6cea6c2dbcc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $36d7a6cea6c2dbcc$var$load("eUrwV").then(()=>parcelRequire('9zs6n'));

});

parcelRegister("dcU0x", function(module, exports) {

let $99d7d752e5b33e72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99d7d752e5b33e72$var$load("2zgDh").then(()=>parcelRequire('7Xwbr'));

});

parcelRegister("iO7I3", function(module, exports) {

let $db12e072c5a651c7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db12e072c5a651c7$var$load("bETPT").then(()=>parcelRequire('hdK8A'));

});

parcelRegister("jat2x", function(module, exports) {

let $df457a364dd20276$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df457a364dd20276$var$load("ceBZg").then(()=>parcelRequire('2VxMN'));

});

parcelRegister("cekPs", function(module, exports) {

let $8e76f30f559a62ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8e76f30f559a62ae$var$load("5STWe").then(()=>parcelRequire('4Wh4F'));

});

parcelRegister("6U9LK", function(module, exports) {

let $506f8cfb12b55347$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $506f8cfb12b55347$var$load("EfE3i").then(()=>parcelRequire('8O7Z4'));

});

parcelRegister("gVZfP", function(module, exports) {

let $c5417c0dfc0e79ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c5417c0dfc0e79ed$var$load("hFqXA").then(()=>parcelRequire('kLJGE'));

});

parcelRegister("emNuY", function(module, exports) {

let $a7598426696e9c94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7598426696e9c94$var$load("4ArgV").then(()=>parcelRequire('13H9y'));

});

parcelRegister("17t4T", function(module, exports) {

let $0d0d002bb24934cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d0d002bb24934cc$var$load("28EDH").then(()=>parcelRequire('Uq9Kn'));

});

parcelRegister("hOImN", function(module, exports) {

let $cf89857e786325fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cf89857e786325fd$var$load("k3mTs").then(()=>parcelRequire('d55ia'));

});

parcelRegister("1Kgrq", function(module, exports) {

let $1456d73be4a91d07$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1456d73be4a91d07$var$load("jJdZ4").then(()=>parcelRequire('KN7Dc'));

});

parcelRegister("bybL2", function(module, exports) {

let $868bfd8110ab5362$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $868bfd8110ab5362$var$load("eZRzs").then(()=>parcelRequire('iF5yO'));

});

parcelRegister("hzFW1", function(module, exports) {

let $ccb63becee365084$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ccb63becee365084$var$load("bLQZ9").then(()=>parcelRequire('6QVDr'));

});

parcelRegister("kjxkN", function(module, exports) {

let $ec9f7080d5dc28ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec9f7080d5dc28ee$var$load("e0E8p").then(()=>parcelRequire('1N8wK'));

});

parcelRegister("7ttEc", function(module, exports) {

let $57123d31064ec9b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57123d31064ec9b4$var$load("4DYJ5").then(()=>parcelRequire('htQvj'));

});

parcelRegister("7OHuB", function(module, exports) {

let $5b0ef0a32cdfebe6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5b0ef0a32cdfebe6$var$load("hfFxJ").then(()=>parcelRequire('j0WBL'));

});

parcelRegister("jpB0s", function(module, exports) {

let $e21d0ed459cba5b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e21d0ed459cba5b6$var$load("gofGr").then(()=>parcelRequire('3MhJQ'));

});

parcelRegister("jCWwP", function(module, exports) {

let $e49ef77cd11b5ed2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e49ef77cd11b5ed2$var$load("aSjrK").then(()=>parcelRequire('2w1Sp'));

});

parcelRegister("lHMT3", function(module, exports) {

let $fcd38911f3085033$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fcd38911f3085033$var$load("7NpX8").then(()=>parcelRequire('h8y2B'));

});

parcelRegister("hJ9kV", function(module, exports) {

let $ce7de1afcb9ee695$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ce7de1afcb9ee695$var$load("bFU3Y").then(()=>parcelRequire('aqqCI'));

});

parcelRegister("5rwHI", function(module, exports) {

let $3f68d7b9efbcb761$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f68d7b9efbcb761$var$load("exaJ2").then(()=>parcelRequire('3xPJL'));

});

parcelRegister("9qEKd", function(module, exports) {

let $6dd625be6f9625ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6dd625be6f9625ed$var$load("hcCcg").then(()=>parcelRequire('7MFNR'));

});

parcelRegister("a7JZv", function(module, exports) {

let $75ee3bb49917093a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $75ee3bb49917093a$var$load("j9KTb").then(()=>parcelRequire('5DyPd'));

});

parcelRegister("aD7ie", function(module, exports) {

let $7bd3342a3bf6e560$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7bd3342a3bf6e560$var$load("3hjAq").then(()=>parcelRequire('l8XHM'));

});

parcelRegister("bKGp5", function(module, exports) {

let $88e4e2124b30625d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88e4e2124b30625d$var$load("2bCHJ").then(()=>parcelRequire('c3dIt'));

});

parcelRegister("c4Nwk", function(module, exports) {

let $8cac457f92dcad07$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cac457f92dcad07$var$load("fdXnq").then(()=>parcelRequire('ekqU6'));

});

parcelRegister("6ZdFN", function(module, exports) {

let $51630bc246f641d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $51630bc246f641d7$var$load("cItJR").then(()=>parcelRequire('3JMfw'));

});

parcelRegister("kbvK1", function(module, exports) {

let $eb1d74e392bb15b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb1d74e392bb15b1$var$load("SctKm").then(()=>parcelRequire('kNuBD'));

});

parcelRegister("cRhRj", function(module, exports) {

let $95c849b0683abf74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95c849b0683abf74$var$load("1fJz1").then(()=>parcelRequire('8WL5R'));

});

parcelRegister("ij8LW", function(module, exports) {

let $d540ce52c5131954$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d540ce52c5131954$var$load("9yA8o").then(()=>parcelRequire('hWeMa'));

});

parcelRegister("4AdNi", function(module, exports) {

let $356539744143d49b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $356539744143d49b$var$load("448N7").then(()=>parcelRequire('fyjTp'));

});

parcelRegister("46LQR", function(module, exports) {

let $2fdcd74f4ecb8583$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2fdcd74f4ecb8583$var$load("gBDdh").then(()=>parcelRequire('3DOrU'));

});

parcelRegister("fcybv", function(module, exports) {

let $b1127e5727eafd30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1127e5727eafd30$var$load("epkdv").then(()=>parcelRequire('fwHlL'));

});

parcelRegister("clAdA", function(module, exports) {

let $8fd38a640f84ba43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8fd38a640f84ba43$var$load("fdczG").then(()=>parcelRequire('lpvU6'));

});

parcelRegister("1Ixw1", function(module, exports) {

let $1403e5f58898b361$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1403e5f58898b361$var$load("3MGOs").then(()=>parcelRequire('eefyR'));

});

parcelRegister("f6Mq7", function(module, exports) {

let $affcf9cbe0876a42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $affcf9cbe0876a42$var$load("innCz").then(()=>parcelRequire('eBv13'));

});

parcelRegister("ak97t", function(module, exports) {

let $7842d892d0e608ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7842d892d0e608ad$var$load("ebljE").then(()=>parcelRequire('8LR5Q'));

});

parcelRegister("glFbo", function(module, exports) {

let $be6e8d8875d506fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be6e8d8875d506fe$var$load("j4dSZ").then(()=>parcelRequire('5tR4J'));

});

parcelRegister("1Hbkf", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $fe3e94e79d9de90d$var$EXPIRY_IN_7_DAYS = 604800;
const $fe3e94e79d9de90d$var$EXPIRY_IN_30_DAYS = 2592000;
const $fe3e94e79d9de90d$export$262c003deb93a450 = async (integration)=>{
    try {
        if ($fe3e94e79d9de90d$export$ee4ac5fe77f8084a(integration)) return true;
        $fe3e94e79d9de90d$export$7a91674e4b755c4b(integration);
        if (!$fe3e94e79d9de90d$export$ee4ac5fe77f8084a(integration)) return true;
        return false;
    } catch  {
        return true;
    }
};
const $fe3e94e79d9de90d$export$64c6861c3bbd89a2 = (integration)=>{
    const value = (0, $17wUi.confluenceLocalStorageInstance).getItem($fe3e94e79d9de90d$var$getVisitedCountStorageKey(integration));
    return parseInt(value, 10) || 0;
};
const $fe3e94e79d9de90d$export$41554dcbb74e65ef = (integration)=>{
    const currentCount = $fe3e94e79d9de90d$export$64c6861c3bbd89a2(integration);
    (0, $17wUi.confluenceLocalStorageInstance).setItem($fe3e94e79d9de90d$var$getVisitedCountStorageKey(integration), currentCount + 1);
};
const $fe3e94e79d9de90d$export$7a91674e4b755c4b = (integration)=>{
    $fe3e94e79d9de90d$var$setFeatureVisited(integration, $fe3e94e79d9de90d$var$EXPIRY_IN_7_DAYS);
};
const $fe3e94e79d9de90d$export$788659dbff920e5f = (integration)=>{
    $fe3e94e79d9de90d$var$setFeatureVisited(integration, $fe3e94e79d9de90d$var$EXPIRY_IN_30_DAYS);
};
const $fe3e94e79d9de90d$var$setFeatureVisited = (integration, expire)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem($fe3e94e79d9de90d$var$getVisitedStorageKey(integration), true, expire);
};
const $fe3e94e79d9de90d$export$ee4ac5fe77f8084a = (integration)=>(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean($fe3e94e79d9de90d$var$getVisitedStorageKey(integration));
const $fe3e94e79d9de90d$export$4ceb2f7d0e405037 = (integration)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem($fe3e94e79d9de90d$var$getOptOutStorageKey(integration), true);
};
const $fe3e94e79d9de90d$export$c74d1fb7a364edae = (integration)=>(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean($fe3e94e79d9de90d$var$getOptOutStorageKey(integration));
function $fe3e94e79d9de90d$var$getOptOutStorageKey(integration) {
    switch(integration){
        case 'crossJoinNudgesV3':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_V3_USER_OPT_OUT;
        case 'crossJoinNudgesConfluenceToJpd':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_JPD_USER_OPT_OUT;
        case 'crossJoinNudgesConfluenceToLoom':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_OPT_OUT;
        default:
            return '';
    }
}
function $fe3e94e79d9de90d$var$getVisitedStorageKey(integration) {
    switch(integration){
        case 'crossJoinNudgesV3':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_V3_VISITED_KEY;
        case 'crossJoinNudgesConfluenceToJpd':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_JPD_VISITED_KEY;
        case 'crossJoinNudgesConfluenceToLoom':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_VISITED_KEY;
        default:
            return '';
    }
}
function $fe3e94e79d9de90d$var$getVisitedCountStorageKey(integration) {
    switch(integration){
        case 'crossJoinNudgesV3':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_V3_VISITED_COUNT;
        case 'crossJoinNudgesConfluenceToJpd':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_JPD_VISITED_COUNT;
        case 'crossJoinNudgesConfluenceToLoom':
            return (0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_VISITED_COUNT;
        default:
            return '';
    }
}
module.exports["isFeatureVisited"] = $fe3e94e79d9de90d$export$262c003deb93a450;
module.exports["getFeatureVisited"] = $fe3e94e79d9de90d$export$ee4ac5fe77f8084a;
module.exports["snoozeFeatureFor7Days"] = $fe3e94e79d9de90d$export$7a91674e4b755c4b;
module.exports["getFeatureVisitedCount"] = $fe3e94e79d9de90d$export$64c6861c3bbd89a2;
module.exports["increaseFeatureVisitedCount"] = $fe3e94e79d9de90d$export$41554dcbb74e65ef;
module.exports["snoozeFeatureFor30Days"] = $fe3e94e79d9de90d$export$788659dbff920e5f;
module.exports["setUserOptedOut"] = $fe3e94e79d9de90d$export$4ceb2f7d0e405037;
module.exports["isUserOptedOut"] = $fe3e94e79d9de90d$export$c74d1fb7a364edae;

});

parcelRegister("biOtS", function(module, exports) {
const $5ce0e61a84ffab65$export$459d2a90e25243eb = 'cross_join_nudges_confluence_to_jpd_experiment';
const $5ce0e61a84ffab65$export$ff0d532025d54d77 = (integration, createAnalyticsEvent, { attributes: commonAttributes = {} } = {})=>(type, actionSubject, action, actionSubjectId, attributes)=>createAnalyticsEvent({
            type: type,
            data: {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                source: integration,
                attributes: {
                    ...commonAttributes,
                    ...attributes
                }
            }
        }).fire();
const $5ce0e61a84ffab65$export$ed26b312f8fb3da = (analytics, error)=>analytics('sendOperationalEvent', 'showCrossJoinNudges', 'failed', undefined, {
        message: String(error),
        details: {
            ...error || {}
        }
    });
const $5ce0e61a84ffab65$export$926c49ee4cec3927 = (analytics)=>analytics('sendUIEvent', 'flag', 'dismissed', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$dfd781a069757128 = (analytics)=>analytics('sendUIEvent', 'flag', 'snoozed', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$b02e37e6448a2f = (analytics)=>analytics('sendUIEvent', 'user', 'optedOut', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$9ca55cf6ee7ca489 = (analytics)=>analytics('sendUIEvent', 'flag', 'shown', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$951f0a85c06c95e8 = (analytics)=>analytics('sendUIEvent', 'joinButton', 'clicked', 'requestAccessFlag');
const $5ce0e61a84ffab65$export$b6a30d1aef42926f = (analytics)=>{
    analytics('sendTrackEvent', 'eligibility', 'checked', undefined, {
        flagKey: 'NON_CONTEXTUAL_CROSS_JOIN_NUDGES',
        ineligibilityReason: 'SITE_OPTED_OUT'
    });
};
const $5ce0e61a84ffab65$export$e19a7f6320c04dee = (analytics, nudgeId)=>{
    analytics('sendTrackEvent', 'eligibility', 'checked', undefined, {
        flagKey: 'NON_CONTEXTUAL_CROSS_JOIN_NUDGES',
        ineligibilityReason: 'MSR_NOT_RECOMMENDED',
        nudgeId: nudgeId
    });
};
const $5ce0e61a84ffab65$export$a303df7e5393c39c = (source, createAnalyticsEvent, { attributes: commonAttributes = {} } = {})=>(type, actionSubject, action, actionSubjectId, attributes)=>createAnalyticsEvent({
            type: type,
            data: {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...commonAttributes,
                    ...attributes
                }
            }
        }).fire();
const $5ce0e61a84ffab65$export$946cc509d91a25c0 = (analytics, error, actionSubject, action, analyticsAttributes)=>analytics('sendOperationalEvent', actionSubject, action, undefined, {
        message: String(error),
        details: {
            ...error || {}
        },
        ...analyticsAttributes
    });
const $5ce0e61a84ffab65$export$ef76abaf7a2fcf22 = (analytics, attributes)=>analytics('sendTrackEvent', 'loomCjnEligibility', 'checked', undefined, attributes);
module.exports["getExperimentAnalytics"] = $5ce0e61a84ffab65$export$ff0d532025d54d77;
module.exports["fireExperimentError"] = $5ce0e61a84ffab65$export$ed26b312f8fb3da;
module.exports["fireFlagDismissed"] = $5ce0e61a84ffab65$export$926c49ee4cec3927;
module.exports["fireFlagSnoozed"] = $5ce0e61a84ffab65$export$dfd781a069757128;
module.exports["fireUserOptedOut"] = $5ce0e61a84ffab65$export$b02e37e6448a2f;
module.exports["fireFlagShown"] = $5ce0e61a84ffab65$export$9ca55cf6ee7ca489;
module.exports["fireJoinButtonClicked"] = $5ce0e61a84ffab65$export$951f0a85c06c95e8;
module.exports["fireSiteOptedOutAnalytics"] = $5ce0e61a84ffab65$export$b6a30d1aef42926f;
module.exports["fireMsrNotRecommendedAnalytics"] = $5ce0e61a84ffab65$export$e19a7f6320c04dee;
module.exports["getCustomExperimentAnalytics"] = $5ce0e61a84ffab65$export$a303df7e5393c39c;
module.exports["fireLoomCjnEligibilityChecked"] = $5ce0e61a84ffab65$export$ef76abaf7a2fcf22;

});

parcelRegister("iuZ4N", function(module, exports) {
const $f476e317aa81769f$export$7663eef720c16d28 = async (product, cloudId, createAnalyticsEvent, source)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    try {
        const response = await fetch(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) {
            // 400 response means the user is not licensed for the product and we want to handle this case so it still caches the result.
            // For other error codes we still want to throw an error so the result is not cached.
            if (response.status === 400) return false;
            else throw new Error(`Unexpected response status: ${response.status}`);
        }
        const capabilities = (await response.json())?.results[resource];
        return capabilities === 'DIRECT_ACCESS' || capabilities === 'REQUEST_ACCESS';
    } catch (err) {
        // Source is required for operational events otherwise it won't fire
        if (createAnalyticsEvent && source) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'fetchError',
                actionSubject: 'capabilitiesCheck',
                source: source,
                attributes: {
                    message: String(err)
                }
            }
        }).fire();
        throw err;
    }
};
module.exports["canUserRequestAccess"] = $f476e317aa81769f$export$7663eef720c16d28;

});

parcelRegister("2RNw9", function(module, exports) {
const $88bc59deeed3fb0a$export$780c542cf1b3e229 = async (product, cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:${product}::site/${cloudId}`
    };
    const response = await fetch('/gateway/api/permissions/permitted', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return (await response.json()).permitted;
};
module.exports["hasAccessToProduct"] = $88bc59deeed3fb0a$export$780c542cf1b3e229;

});

parcelRegister("150tu", function(module, exports) {
const $fa075ae88637f89d$export$23b7746c9e6ae406 = async (product, cloudId)=>{
    const traitName = $fa075ae88637f89d$var$ACTIVATION_TRAITS[product] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product ${product}`);
    const siteTraits = await $fa075ae88637f89d$var$fetchSitePersonalization(cloudId);
    const productActivation = siteTraits.find((trait)=>trait.name === traitName);
    if (productActivation?.value) {
        const oneWeekLaterActivation = new Date(productActivation?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};
const $fa075ae88637f89d$export$e7b898c6b427cf14 = async (cloudId)=>{
    const traitName = $fa075ae88637f89d$var$ACTIVATION_TRAITS['loom'] || undefined;
    if (!traitName) throw Error(`Unknown activation trait key for site product Loom}`);
    const siteTraits = await $fa075ae88637f89d$var$fetchSitePersonalization(cloudId);
    const productActivation = siteTraits.find((trait)=>trait.name === traitName);
    if (productActivation?.value) {
        const oneWeekLaterActivation = new Date(productActivation?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return true;
};
const $fa075ae88637f89d$var$ACTIVATION_TRAITS = {
    'jira-software': 'jira-software.ondemand.activationDate',
    'jira-product-discovery': 'jira-product-discovery.activationDate',
    confluence: 'confluence.ondemand.activationDate',
    loom: 'loom.activationDate'
};
const $fa075ae88637f89d$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $fa075ae88637f89d$var$fetchSitePersonalization = async (cloudId)=>{
    const response = await fetch($fa075ae88637f89d$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isSite7DaysOld"] = $fa075ae88637f89d$export$23b7746c9e6ae406;
module.exports["isLoomSite7DaysOld"] = $fa075ae88637f89d$export$e7b898c6b427cf14;

});

parcelRegister("lRCxi", function(module, exports) {
const $6d3a2f07b0875b27$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await $6d3a2f07b0875b27$var$fetchSitePersonalization(cloudId);
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};
const $6d3a2f07b0875b27$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $6d3a2f07b0875b27$var$fetchSitePersonalization = async (cloudId)=>{
    const response = await fetch($6d3a2f07b0875b27$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isSiteOptedOut"] = $6d3a2f07b0875b27$export$3475487c10c1ac17;

});

parcelRegister("aHsHn", function(module, exports) {
const $7fb0822596b2feb3$export$9641ccd51cea648b = async (cloudId, userId, trait)=>{
    const requiredDaysActive = 14;
    const userTraits = await $7fb0822596b2feb3$var$fetchUserPersonalization(cloudId, userId);
    const activationDateTrait = userTraits.find((t)=>t.name === trait);
    if (!activationDateTrait || typeof activationDateTrait.value !== 'string') return true;
    const activationDate = new Date(activationDateTrait.value);
    return $7fb0822596b2feb3$export$9b2c7fafd3ba5799(activationDate, requiredDaysActive);
};
const $7fb0822596b2feb3$export$9b2c7fafd3ba5799 = (startDate, thresholdDays)=>{
    const today = new Date();
    const dateAfterThreshold = new Date(startDate);
    dateAfterThreshold.setDate(startDate.getDate() + thresholdDays);
    return today <= dateAfterThreshold;
};
const $7fb0822596b2feb3$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $7fb0822596b2feb3$var$fetchUserPersonalization = async (cloudId, userId)=>{
    const response = await fetch($7fb0822596b2feb3$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isUserTooNew"] = $7fb0822596b2feb3$export$9641ccd51cea648b;

});

parcelRegister("hYAxW", function(module, exports) {
const $b7194d4ca9996ac0$var$ONE_DAY_IN_MILLISECONDS = 86400000;
function $b7194d4ca9996ac0$export$6cca8a222d1193d7() {
    let queue = [];
    let locked = false;
    const acquireLock = ()=>{
        return new Promise((resolve)=>{
            const releaseLock = ()=>{
                locked = false;
                processQueue();
            };
            const grantLock = ()=>{
                locked = true;
                resolve(releaseLock);
            };
            if (locked) queue.push(()=>{
                grantLock();
            });
            else grantLock();
        });
    };
    const processQueue = ()=>{
        if (queue.length > 0) {
            const resolveNextItem = queue.shift();
            if (resolveNextItem) resolveNextItem();
        }
    };
    return {
        acquireLock: acquireLock
    };
}
function $b7194d4ca9996ac0$export$61c308f36d3fce82(control) {
    const mutex = $b7194d4ca9996ac0$export$6cca8a222d1193d7();
    function getControlCache() {
        const possibleObject = control.get();
        if (possibleObject === undefined || possibleObject === null || possibleObject === '') return {};
        return possibleObject;
    }
    return {
        get: async (key)=>{
            const releaseLock = await mutex.acquireLock();
            const storedValues = getControlCache();
            const storedCheck = storedValues[key];
            if (storedCheck !== null && storedCheck !== undefined) {
                const { value: { value: value, ttl: ttl } } = storedCheck;
                const pastTtl = ttl ? ttl < Date.now() : false;
                if (pastTtl) {
                    releaseLock();
                    return undefined;
                }
                releaseLock();
                return value;
            }
            releaseLock();
            return undefined;
        },
        set: async (key, value, daysToLive)=>{
            const releaseLock = await mutex.acquireLock();
            const storedValues = getControlCache();
            const keyValue = {
                value: {
                    value: value,
                    ...daysToLive ? {
                        ttl: new Date().getTime() + $b7194d4ca9996ac0$var$ONE_DAY_IN_MILLISECONDS * daysToLive
                    } : {}
                },
                timestamp: Date.now()
            };
            storedValues[key] = keyValue;
            control.set(storedValues);
            releaseLock();
        },
        delete: async (key)=>{
            const releaseLock = await mutex.acquireLock();
            const object = control.get();
            delete object[key];
            control.set(object);
            releaseLock();
        },
        deleteAll: async ()=>{
            const releaseLock = await mutex.acquireLock();
            control.delete();
            releaseLock();
        }
    };
}
function $b7194d4ca9996ac0$export$d932b194d241af5e(cache) {
    function withEligibilityCache(key, eligibilityCheck, daysToLive) {
        return async (...args)=>{
            try {
                const cachedValue = await cache.get(key);
                if (cachedValue !== undefined && cachedValue !== null) return cachedValue;
            } catch (e) {
            // cache get fail, do nothing
            }
            const result = await eligibilityCheck(...args);
            try {
                await cache.set(key, result, daysToLive);
            } catch (e) {
            // cache set fail, do nothing
            }
            return result;
        };
    }
    return withEligibilityCache;
}



var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $0ca9c4cacb4d1123$var$cjnEligibilityCacheController = {
    get: ()=>(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_ELIGIBILITY_KEY),
    set: (value)=>(0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_ELIGIBILITY_KEY, value),
    delete: ()=>(0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_ELIGIBILITY_KEY)
};
const $0ca9c4cacb4d1123$export$beb12117dd89482e = (0, $b7194d4ca9996ac0$export$61c308f36d3fce82)($0ca9c4cacb4d1123$var$cjnEligibilityCacheController);
const $0ca9c4cacb4d1123$export$86938f072bd79cac = (0, $b7194d4ca9996ac0$export$d932b194d241af5e)($0ca9c4cacb4d1123$export$beb12117dd89482e);
const $0ca9c4cacb4d1123$export$9fafd3f54ebb3132 = {
    get: (key)=>{
        const storedValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY);
        if (!storedValue) return undefined;
        const storedValueObject = JSON.parse(storedValue);
        return storedValueObject[key];
    },
    set: (key, value)=>{
        const storedValue = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY) ?? '{}');
        storedValue[key] = value;
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY, JSON.stringify(storedValue));
    },
    delete: (key)=>{
        const storedValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY) ?? {};
        delete storedValue[key];
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CROSS_JOIN_NUDGES_EVENT_CACHE_KEY, JSON.stringify(storedValue));
    }
};
const $0ca9c4cacb4d1123$export$2a72056994381bc4 = async ()=>{
    await $0ca9c4cacb4d1123$export$beb12117dd89482e.set('local_storage_enabled', true);
    const value = await $0ca9c4cacb4d1123$export$beb12117dd89482e.get('local_storage_enabled');
    return value === true;
};
const $0ca9c4cacb4d1123$export$d172f6d49154a44b = async ()=>{
    try {
        // overwrite the key even if it exists
        await $0ca9c4cacb4d1123$export$beb12117dd89482e.set('has_seen_nudge_in_last_7_days', true);
    } catch (e) {
    // cache set fail, do nothing
    }
};
const $0ca9c4cacb4d1123$export$f03b4069dddacff6 = async ()=>{
    try {
        return !!await $0ca9c4cacb4d1123$export$beb12117dd89482e.get('has_seen_nudge_in_last_7_days');
    } catch (e) {
    // cache get fail, return false
    }
    return false;
};
module.exports["withEligibilityCache"] = $0ca9c4cacb4d1123$export$86938f072bd79cac;
module.exports["cjnLoomEventCacheController"] = $0ca9c4cacb4d1123$export$9fafd3f54ebb3132;
module.exports["isCacheEnabled"] = $0ca9c4cacb4d1123$export$2a72056994381bc4;
module.exports["setHasSeenNudgeInLast7Days"] = $0ca9c4cacb4d1123$export$d172f6d49154a44b;
module.exports["getHasSeenNudgeInLast7Days"] = $0ca9c4cacb4d1123$export$f03b4069dddacff6;

});

parcelRegister("fg10r", function(module, exports) {

let $b1b92168f648ab1a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1b92168f648ab1a$var$load("b2zon").then(()=>parcelRequire('3hjAC'));

});

parcelRegister("2qwfL", function(module, exports) {

let $1c47074bd9799721$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c47074bd9799721$var$load("bP6pn").then(()=>parcelRequire('iII7v'));

});

parcelRegister("HH4KZ", function(module, exports) {

let $08356e356732b24a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $08356e356732b24a$var$load("7EorR"),
    $08356e356732b24a$var$load("3Ap7H")
]).then(()=>parcelRequire('hcbgd'));

});

parcelRegister("5GsAe", function(module, exports) {

let $42370c13736914fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $42370c13736914fc$var$load("aPSID").then(()=>parcelRequire('7DERG'));

});

parcelRegister("fQudG", function(module, exports) {

let $b8932758dfb3687a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b8932758dfb3687a$var$load("dj3mE").then(()=>parcelRequire('2pYxO'));

});

parcelRegister("iqdmV", function(module, exports) {

let $d695067a486f4274$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d695067a486f4274$var$load("jfplD"),
    $d695067a486f4274$var$load("favdH"),
    $d695067a486f4274$var$load("ktyyJ")
]).then(()=>parcelRequire('1VYG6'));

});

parcelRegister("bVAxT", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $T1bCI.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}
module.exports["RestrictionsDialogStateContainer"] = $20c3e8ab10e63e24$export$f91385b453474810;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

var $jIOyV = parcelRequire("jIOyV");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip,
        __callerPackage__: "@confluence/storage-enforcement"
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("lBYCH", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1e166e9bfc301d21$export$695e6f0ac03b03ae = (0, $42omo.createContext)({
    isBranchDeploy: false
});
$1e166e9bfc301d21$export$695e6f0ac03b03ae.displayName = 'AppNavigationContext';
module.exports["AppNavigationContext"] = $1e166e9bfc301d21$export$695e6f0ac03b03ae;

});

parcelRegister("1KBSi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $fEhQK = parcelRequire("fEhQK");

const $15029de520f1b9e8$export$cadd7e072478f5e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(7);
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const t0 = !isLicensed;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            skip: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { data: canCreateData, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $fEhQK.default), {
        ...t1,
        __callerPackage__: "@confluence/create-space"
    });
    let t2;
    if ($[2] !== canCreateData?.user?.confluence?.operations) {
        t2 = canCreateData?.user?.confluence?.operations.some($15029de520f1b9e8$var$_temp);
        $[2] = canCreateData?.user?.confluence?.operations;
        $[3] = t2;
    } else t2 = $[3];
    const canCreateSpace = Boolean(t2);
    let t3;
    if ($[4] !== canCreateSpace || $[5] !== loading) {
        t3 = {
            canCreateSpace: canCreateSpace,
            loading: loading
        };
        $[4] = canCreateSpace;
        $[5] = loading;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: canCreateData, loading: loading } = (0, $jMyy4.useQueryInterop)(// Due to circular dependency issues we are using the PreloadCreateSpaceQuery from create-space-preload package
    (0, $fEhQK.default), {
        skip: !isLicensed,
        __callerPackage__: "@confluence/create-space"
    });
    const canCreateSpace = Boolean(canCreateData?.user?.confluence?.operations.some((obj)=>obj?.operation === 'create_space'));
    return {
        canCreateSpace: canCreateSpace,
        loading: loading
    };
};
function $15029de520f1b9e8$var$_temp(obj) {
    return obj?.operation === "create_space";
}
module.exports["useCanCreateSpace"] = $15029de520f1b9e8$export$cadd7e072478f5e;

});

parcelRegister("cSVAY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $eE3dj = parcelRequire("eE3dj");


var $fkOJz = parcelRequire("fkOJz");


const $c09757da0c891efc$export$758fc7bfe6cba448 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "langk",
    name: "RestrictionsButtonLoaderPaint",
    loader: async ()=>(await (parcelRequire("bkKfl"))).RestrictionsButton,
    loading: (0, $fkOJz.RestrictionsButtonLoading)
});

const $c09757da0c891efc$export$92f59ae572209281 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZXc7l",
    name: "RestrictionsButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("bkKfl"))).RestrictionsButton,
    loading: (0, $eE3dj.RestrictionsButtonPlaceholder)
});
module.exports["RestrictionsButtonLoaderPaint"] = $c09757da0c891efc$export$758fc7bfe6cba448;
module.exports["RestrictionsButtonLoaderAfterPaint"] = $c09757da0c891efc$export$92f59ae572209281;

});

parcelRegister("eE3dj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $cb1652ec96a3881c$export$f7c9f842c83767d4 = (0, $3u0dr.isReactCompilerActiveV2)() ? function RestrictionsButtonPlaceholder() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "restrictions-button-placeholder",
            "data-test-id": "restrictions-button-placeholder",
            style: {
                width: 32,
                height: 32
            }
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RestrictionsButtonPlaceholder() {
    // The RestrictionsDialog will be positioned based on the initial dimensions of
    // RestrictionsButton, so we need to render a placeholder instead of `null`
    // This placeholder is also used in SSR.
    // All the place that is waiting for data in restrictions package should use this placeholder instead of null.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "restrictions-button-placeholder",
        "data-test-id": "restrictions-button-placeholder",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: 32,
            height: 32
        }
    });
};
module.exports["RestrictionsButtonPlaceholder"] = $cb1652ec96a3881c$export$f7c9f842c83767d4;

});

parcelRegister("fkOJz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eE3dj = parcelRequire("eE3dj");

const $560660f3777cb1ae$export$3375d726052961a6 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
};
module.exports["RestrictionsButtonLoading"] = $560660f3777cb1ae$export$3375d726052961a6;

});

parcelRegister("bkKfl", function(module, exports) {

let $84056f94e7772e1b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $84056f94e7772e1b$var$load("4KvE8"),
    $84056f94e7772e1b$var$load("W7CG2"),
    $84056f94e7772e1b$var$load("dafa3"),
    $84056f94e7772e1b$var$load("im7NY"),
    $84056f94e7772e1b$var$load("6wr18"),
    $84056f94e7772e1b$var$load("ffEVr"),
    $84056f94e7772e1b$var$load("bfhXH")
]).then(()=>parcelRequire('l5Yc7'));

});

parcelRegister("4S8ti", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9HkI0 = parcelRequire("9HkI0");


var $inPa6 = parcelRequire("inPa6");







// Events
const $ced3a33160abceeb$export$38f20466f22f45f0 = 'CLICK_PRIVACY_POLICY_LINK';
const $ced3a33160abceeb$export$836f30b3a88d4259 = 'UNDO_DISMISSAL_STARTED';
const $ced3a33160abceeb$export$5ee3f53555c01a95 = 'UNDO_DISMISSAL_SUCCEEDED';
const $ced3a33160abceeb$export$eebf6a2671000e28 = 'UNDO_DISMISSAL_FAILED';
const $ced3a33160abceeb$export$14b7e2c312f27acd = 'atlassian-growth-recos';


function $046cb65f983803a0$export$a079a83b07f794bf(value) {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if (typeof value === 'object' && Object.keys(value).length === 0) return false;
    return true;
}
function $046cb65f983803a0$export$31553aaa555c1514(contextResolver, checkUseCase = true) {
    const context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
    if (checkUseCase && (typeof context?.useCase !== 'string' || context?.useCase.trim().length === 0)) throw new Error('useCase is required');
    return context;
}



class $33d16fd926db52d3$export$2e2bcd8739ae039 {
    getHeaders() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    }
    getContext(contextResolver) {
        return (0, $046cb65f983803a0$export$31553aaa555c1514)(contextResolver);
    }
    constructor(endpoint){
        this.endpoint = endpoint;
    }
}


class $5e1f700bb1e33e2f$export$2e2bcd8739ae039 extends (0, $33d16fd926db52d3$export$2e2bcd8739ae039) {
    makeRequest(makeRequestParams) {
        const { contextResolver: contextResolver, first: first, rerank: rerank } = makeRequestParams;
        return new Request(this.endpoint, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: this.getHeaders(),
            body: JSON.stringify({
                query: $5e1f700bb1e33e2f$var$recommendationsQuery,
                variables: {
                    first: first,
                    context: this.getContext(contextResolver),
                    rerank: rerank
                }
            })
        });
    }
}
const $5e1f700bb1e33e2f$var$recommendationsQuery = `
query GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {
  growthRecommendations {
    recommendations(context: $context, first: $first, rerank: $rerank) {
      ... on GrowthRecRecommendations {
        __typename
        data {
          __typename
          entityId
          reasons
        }
      }
      ... on QueryError {
        __typename
        identifier
        message
        extensions {
          __typename
          statusCode
          errorType
        }
      }
    }
  }
}
`;


class $f32b9853811025b6$export$d0a1abfd57dc5018 {
    constructor(code, reason, response){
        this.code = code;
        this.reason = reason;
        this.response = response;
    }
}
class $f32b9853811025b6$var$QueryResultCreator {
}
class $f32b9853811025b6$export$ad7cb7f4450dd7c4 extends $f32b9853811025b6$var$QueryResultCreator {
    makeQueryResult() {
        return new $f32b9853811025b6$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText);
    }
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
}
class $f32b9853811025b6$export$553722ecbbe27276 extends $f32b9853811025b6$var$QueryResultCreator {
    makeQueryResult() {
        const [{ extensions: extensions }] = this.errors;
        const [{ statusCode: statusCode, errorType: errorType }] = Array.isArray(extensions) ? extensions : [
            extensions
        ];
        return new $f32b9853811025b6$export$d0a1abfd57dc5018(statusCode, errorType, {
            errors: this.errors.map((error)=>error.message)
        });
    }
    constructor(errors){
        super(), this.errors = errors;
    }
}
class $f32b9853811025b6$export$ff264bfdc9a404eb extends $f32b9853811025b6$var$QueryResultCreator {
    makeQueryResult() {
        return new $f32b9853811025b6$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText, {
            errors: [
                'Received data has missing attributes'
            ]
        });
    }
    constructor(fetchResponse){
        super(), this.fetchResponse = fetchResponse;
    }
}
class $f32b9853811025b6$export$6b16771e962990ff extends $f32b9853811025b6$var$QueryResultCreator {
    constructor(response, data){
        super(), this.response = response, this.data = data;
    }
}


class $0480229b9a520ecb$export$c02f0b31b3b527a3 extends (0, $f32b9853811025b6$export$6b16771e962990ff) {
    makeQueryResult() {
        return new (0, $f32b9853811025b6$export$d0a1abfd57dc5018)(this.response.status, this.response.statusText, {
            data: this.data
        });
    }
    constructor(response, data){
        super(response, data), this.response = response;
    }
}


class $2dbfb4e6f44d9269$export$7f19312509e0d2c0 {
    extract(response) {
        return response?.recommendations?.data ?? [];
    }
    getSuccessResultCreator(response, result) {
        return new (0, $0480229b9a520ecb$export$c02f0b31b3b527a3)(response, result);
    }
}



class $9f8e6801fd127c12$export$2e2bcd8739ae039 {
    async get(request) {
        return undefined;
    }
    async set(request, response) {
        return;
    }
    async delete(request) {
        return true;
    }
}


const $306861b3dd4a3a29$var$DEFAULT_TTL = 60;
class $306861b3dd4a3a29$export$2e2bcd8739ae039 {
    get cacheName() {
        return this.cacheProviderConfig.cacheName;
    }
    get useCase() {
        return this.cacheProviderConfig.useCase;
    }
    get ttl() {
        return this.cacheProviderConfig.ttl ?? $306861b3dd4a3a29$var$DEFAULT_TTL;
    }
    get onError() {
        return this.cacheProviderConfig.onError ?? (()=>{});
    }
    constructor(cacheProviderConfig){
        this.cacheProviderConfig = cacheProviderConfig;
    }
}


class $28285a544c090e2e$export$2e2bcd8739ae039 {
    /**
   * Set the expiry date of the cached response
   */ async setExpiry(key, expireAt) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.put(expireAt, key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
   * Get the expiry date of the cached response
   */ async getExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readonly');
                const storeRequest = store.get(key);
                storeRequest.onsuccess = ()=>{
                    resolve(Number(storeRequest.result ?? 0));
                };
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    async deleteExpiry(key) {
        return new Promise((resolve, reject)=>{
            const dbRequest = this.initDb();
            dbRequest.onsuccess = ()=>{
                const store = this.getObjectStore(dbRequest, 'readwrite');
                store.delete(key);
                resolve();
            };
            dbRequest.onerror = ()=>{
                if (dbRequest.error) reject(dbRequest.error);
            };
        });
    }
    /**
   * Initialise the IndexedDB
   */ initDb() {
        const dbRequest = indexedDB.open(`${this.cacheConfig.cacheName}-expiry`);
        dbRequest.onupgradeneeded = ()=>{
            const db = dbRequest.result;
            db.createObjectStore(this.expiryStoreName);
        };
        return dbRequest;
    }
    /**
   * Get the object store from the IndexedDB
   */ getObjectStore(dbRequest, mode = 'readwrite') {
        const db = dbRequest.result;
        return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
    }
    /**
   * Initialise the ExpiryStorage
   */ constructor(cacheConfig){
        this.cacheConfig = cacheConfig;
        this.expiryStoreName = 'expiries';
    }
}


class $ad3f63563cb22b21$export$2e2bcd8739ae039 {
    /**
   * Get cached response
   */ async get(request) {
        if (!this.supported) return undefined;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expired = await this.isExpired(request);
            if (expired) {
                await this.delete(request);
                return undefined;
            }
            return cache.match(this.getCacheKey(request));
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
   * Put response in cache
   */ async set(request, response) {
        if (!this.supported) return;
        try {
            const cache = await caches.open(this.cacheConfig.cacheName);
            const expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
            await this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
            await cache.put(this.getCacheKey(request), response);
        } catch (e) {
            this.cacheConfig.onError(e);
        }
    }
    /**
   * Delete cached response
   */ async delete(request) {
        if (!this.supported) return true;
        try {
            return caches.open(this.cacheConfig.cacheName).then(async (cache)=>{
                await cache.delete(this.getCacheKey(request));
                await this.expiryStorage.deleteExpiry(this.getStoreKey(request));
                return true;
            });
        } catch (e) {
            this.cacheConfig.onError(e);
            return false;
        }
    }
    /**
   * Check if the cached response is expired
   */ async isExpired(request) {
        try {
            const key = this.getStoreKey(request);
            const expiry = await this.expiryStorage.getExpiry(key);
            return Date.now() > (expiry ?? 0);
        } catch (error) {
            this.cacheConfig.onError(error instanceof Error ? error : new Error('Error checking expiry'));
            return true;
        }
    }
    /**
   * Compose the URL and the use case as the search params to cache the response
   */ getCacheKey(request) {
        const url = new URL(request.url);
        url.searchParams.set('useCase', this.cacheConfig.useCase);
        return url;
    }
    /**
   * Get the key to store the response
   * Interally, it hashes the request body to get a unique key
   */ getStoreKey(request) {
        return this.getCacheKey(request).toString();
    }
    /**
   * Initialise the WebCacheStorage
   * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
   * @param onError a callback when any error occurs
   */ constructor(cacheProviderConfig){
        /**
     * Whether the Cache API is supported
     */ this.supported = void 0;
        /**
     * Expiry storage
     */ this.expiryStorage = void 0;
        this.cacheConfig = void 0;
        this.supported = typeof caches === 'object' && typeof caches.open === 'function';
        this.cacheConfig = new (0, $306861b3dd4a3a29$export$2e2bcd8739ae039)(cacheProviderConfig);
        this.expiryStorage = new (0, $28285a544c090e2e$export$2e2bcd8739ae039)(this.cacheConfig);
    }
}


class $7ab716f7d2388209$export$2e2bcd8739ae039 {
    /**
   * Returns the cache provider based on the given cache configuration
   *
   * @param cacheConfig The cache configuration to use
   * @returns The cache provider
   */ static resolve(cacheConfig) {
        if (cacheConfig) return new (0, $ad3f63563cb22b21$export$2e2bcd8739ae039)(cacheConfig);
        return new (0, $9f8e6801fd127c12$export$2e2bcd8739ae039)();
    }
}


class $01e78e6aa98b5954$export$2e2bcd8739ae039 {
    /**
   * Fetches the response by the given request from the cache or the API
   * the cache config is optional, if not provided, the response will not be cached
   *
   * @param request The request to fetch the response from
   * @param cacheConfig The cache configuration to use
   * @returns The query result
   */ fetch(request, { cacheConfig: cacheConfig } = {}) {
        return new Promise(async (resolve, reject)=>{
            const response = await this.getResponse(request, cacheConfig);
            if (!response.ok) return reject(new (0, $f32b9853811025b6$export$ad7cb7f4450dd7c4)(response).makeQueryResult());
            const json = await response.json();
            if (json.errors) return reject(new (0, $f32b9853811025b6$export$553722ecbbe27276)(json.errors).makeQueryResult());
            const schemaResponse = json?.data?.growthRecommendations;
            const queryRes = this.broker.extract(schemaResponse);
            // Undefined is not expected as a valid response from GraphQL
            if (queryRes === undefined) return reject(new (0, $f32b9853811025b6$export$ff264bfdc9a404eb)(response).makeQueryResult());
            return resolve(this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult());
        });
    }
    /**
   * Fetches the response by tha given request from the cache or the API
   * the cache config is optional, if not provided, the response will not be cached
   *
   * @param request The request to fetch the response from
   * @param cacheConfig The cache configuration to use
   * @returns The response from the request
   */ async getResponse(request, cacheConfig) {
        const cacheProvider = (0, $7ab716f7d2388209$export$2e2bcd8739ae039).resolve(cacheConfig);
        const cachedResponse = await cacheProvider.get(request);
        // If the response is cached, return it
        if (cachedResponse) return cachedResponse;
        // Clone the request before it being used to be able to use it multiple times
        const clonedRequest = request.clone();
        return fetch(request).then((response)=>{
            // Cache response only if the response is ok
            if (response.ok) cacheProvider.set(clonedRequest, response.clone());
            return response;
        });
    }
    constructor(broker){
        this.broker = broker;
    }
}


const $2bd3878531988bc1$var$useRecommendations = ({ endpoint: endpoint = '/gateway/api/graphql', contextResolver: contextResolver })=>{
    /**
   * Fetch recommendations for a given context
   */ const getRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((args, deprecatedRerank = [])=>{
        // Deconstruct the args object with deprecated arguments to make it backwards compatible
        const { first: first, rerank: rerank, config: { cacheConfig: cacheConfig } = {
            cacheConfig: undefined
        } } = typeof args === 'number' ? {
            first: args,
            rerank: deprecatedRerank
        } : args;
        const recommendationRequestMaker = new (0, $5e1f700bb1e33e2f$export$2e2bcd8739ae039)(endpoint);
        const requester = new (0, $01e78e6aa98b5954$export$2e2bcd8739ae039)(new (0, $2dbfb4e6f44d9269$export$7f19312509e0d2c0)());
        const context = (0, $046cb65f983803a0$export$31553aaa555c1514)(contextResolver);
        return requester.fetch(recommendationRequestMaker.makeRequest({
            contextResolver: contextResolver,
            first: first,
            rerank: rerank
        }), {
            cacheConfig: cacheConfig ? {
                ...cacheConfig,
                cacheName: (0, $ced3a33160abceeb$export$14b7e2c312f27acd),
                useCase: context.useCase
            } : undefined
        });
    }, [
        contextResolver,
        endpoint
    ]);
    return {
        getRecommendations: getRecommendations
    };
};
var $2bd3878531988bc1$export$2e2bcd8739ae039 = $2bd3878531988bc1$var$useRecommendations;


const $72eddac512bc7ced$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE = 'crossJoinNudgeFlags';
class $72eddac512bc7ced$export$f6f4711ce6617505 extends Error {
    constructor(message, options){
        super(message);
        this.options = void 0;
        this.name = 'RecommendationError';
        this.options = options;
    }
}
function $72eddac512bc7ced$export$e87e269d0f71e3a3({ product: product, sessionId: sessionId, cloudId: cloudId, subProduct: subProduct }) {
    const contextResolver = (0, $42omo.useCallback)(()=>({
            product: product,
            useCase: $72eddac512bc7ced$var$MSR_CROSS_JOIN_NUDGE_RECOMMENDATIONS_USE_CASE,
            tenantId: cloudId,
            subproduct: subProduct,
            sessionId: sessionId
        }), [
        cloudId,
        product,
        subProduct,
        sessionId
    ]);
    const { getRecommendations: getRecommendations } = (0, $2bd3878531988bc1$export$2e2bcd8739ae039)({
        contextResolver: contextResolver
    });
    return (0, $42omo.useCallback)(async ()=>{
        try {
            const result = await getRecommendations({
                first: 4,
                config: {
                    cacheConfig: {
                        ttl: 86400 // cache for 1 day in seconds
                    }
                }
            });
            const { response: { data: data } = {} } = result;
            const recommendedEntities = (data ?? []).map((e)=>e.entityId);
            return recommendedEntities;
        } catch (error) {
            let cause;
            if (error instanceof Error) cause = error;
            else if (error && error.reason) cause = new Error(error.reason);
            else cause = new Error(String(error));
            throw new $72eddac512bc7ced$export$f6f4711ce6617505('Get MSR nudge recommendations error', {
                cause: cause
            });
        }
    }, [
        getRecommendations
    ]);
}



var $dPJCf = parcelRequire("dPJCf");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");








var $biOtS = parcelRequire("biOtS");


var $hYAxW = parcelRequire("hYAxW");

const $3f1df2e5e7061ec6$export$57ede52633f7b520 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const customAnalytics = (0, $biOtS.getCustomExperimentAnalytics)('crossJoinNudges', createAnalyticsEvent);
    /**
   * Fire event only in case the event value has not been cached or cached value is different
   * to prevent excessive number of analytics calls.
   */ return (0, $42omo.useCallback)(({ value: value, key: key })=>{
        try {
            const cachedValue = (0, $hYAxW.cjnLoomEventCacheController).get(key);
            if (!cachedValue || cachedValue.eligible !== value.eligible || cachedValue.ineligibilityReason !== value.ineligibilityReason) {
                (0, $biOtS.fireLoomCjnEligibilityChecked)(customAnalytics, {
                    ...value,
                    key: key
                });
                (0, $hYAxW.cjnLoomEventCacheController).set(key, value);
            }
        } catch (e) {
        // cache get fail, do nothing
        }
    }, [
        customAnalytics
    ]);
};




const $40e69e7df4e12fd0$export$b73ba4b3997f9abe = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId, userId: userId, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireOnlyNewLoomEvent = (0, $3f1df2e5e7061ec6$export$57ede52633f7b520)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const getMSRNudgeRecommendations = (0, $72eddac512bc7ced$export$e87e269d0f71e3a3)({
        product: 'confluence',
        sessionId: (0, $9HkI0.v4)(),
        cloudId: cloudId,
        subProduct: ''
    });
    (0, $42omo.useEffect)(()=>{
        const execCrossJoinNudge = async ()=>{
            if (userId) {
                const { checkLoomCrossJoinNudgeEligibility: checkLoomCrossJoinNudgeEligibility, showLoomCrossJoinNudge: showLoomCrossJoinNudge } = await (parcelRequire("fg10r"));
                const isLoomCrossJoinNudgesEligible = await checkLoomCrossJoinNudgeEligibility({
                    cloudId: cloudId,
                    userId: userId,
                    createAnalyticsEvent: createAnalyticsEvent
                });
                if (isLoomCrossJoinNudgesEligible.eligible) {
                    await showLoomCrossJoinNudge({
                        cloudId: cloudId,
                        userId: userId,
                        displayName: displayName,
                        flags: flags,
                        createAnalyticsEvent: createAnalyticsEvent,
                        formatMessage: formatMessage
                    });
                    return;
                }
                // Track eligibility failure reasons
                fireOnlyNewLoomEvent({
                    value: isLoomCrossJoinNudgesEligible,
                    key: 'cjn-conf-loom'
                });
            }
            const { checkJpdCrossJoinNudgeEligibility: checkJpdCrossJoinNudgeEligibility, showJpdCrossJoinNudge: showJpdCrossJoinNudge, triggerJiraCrossJoinNudge: triggerJiraCrossJoinNudge } = await Promise.resolve((parcelRequire("8AKrx")));
            const isJpdCrossJoinNudgesEligible = await checkJpdCrossJoinNudgeEligibility({
                cloudId: cloudId,
                userId: userId,
                createAnalyticsEvent: createAnalyticsEvent,
                getMSRNudgeRecommendations: getMSRNudgeRecommendations
            });
            if (isJpdCrossJoinNudgesEligible) await showJpdCrossJoinNudge({
                cloudId: cloudId,
                userId: userId,
                displayName: displayName,
                flags: flags,
                createAnalyticsEvent: createAnalyticsEvent,
                push: push,
                formatMessage: formatMessage
            });
            else await triggerJiraCrossJoinNudge({
                cloudId: cloudId,
                userId: userId,
                displayName: displayName,
                flags: flags,
                createAnalyticsEvent: createAnalyticsEvent,
                push: push,
                formatMessage: formatMessage,
                getMSRNudgeRecommendations: getMSRNudgeRecommendations
            });
        };
        execCrossJoinNudge();
    // Disabling as we only want this to execute based on `execCrossJoinNudge` or if `flags` gets updated.
    // This prevents edge cases where flags might be shown twice due to
    // Complex dependency arrays of children components/dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flags
    ]);
};
const $40e69e7df4e12fd0$export$6e567f651a10d419 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    $40e69e7df4e12fd0$export$b73ba4b3997f9abe({
        flags: flags
    });
    return null;
});
module.exports["CrossJoinNudgesWithFlags"] = $40e69e7df4e12fd0$export$6e567f651a10d419;

});

parcelRegister("2IyA1", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b7ebdacf1aaf3f09$export$c1e568f41a04bfb1 = (0, $aXWIB.defineMessages)({
    jpdValueProp: {
        id: "cross-join-nudges.non-contextual-note.jpd-value-prop",
        defaultMessage: "{requestingUser} needs Jira Product Discovery access to prioritize ideas and create roadmaps."
    },
    jiraValueProp: {
        id: "cross-join-nudges.non-contextual-note.jira-value-prop",
        defaultMessage: "{requestingUser} needs Jira access to plan and track work."
    },
    loomValueProp: {
        id: "cross-join-nudges.non-contextual-note.loom-value-prop",
        defaultMessage: "{requestingUser} needs Loom access to create and edit videos."
    },
    confluenceValueProp: {
        id: "cross-join-nudges.non-contextual-note.confluence-value-prop",
        defaultMessage: "{requestingUser} needs Confluence access to collaborate on pages and whiteboards."
    }
});
module.exports["nonContextualNoteMessages"] = $b7ebdacf1aaf3f09$export$c1e568f41a04bfb1;

});


//# sourceMappingURL=GlobalComponents.bc8bc6f2.js.map
